/*
 * De geurquiz: zeven vragen, en daarna zes geuren met uitleg waarom.
 *
 * Dit bestand gaat over schermen en antwoorden. Het rekenwerk staat in
 * geurquiz-model.js en de gegevens in geurindex.json -- dat is met opzet
 * gescheiden, zodat de acceptatietests op het model kunnen draaien zonder
 * browser.
 *
 * Merkregel: nergens een designer-merknaam, nergens "dupe" of "geïnspireerd op".
 */
(function () {
  'use strict';

  var wortel = document.querySelector('[data-geurquiz]');
  if (!wortel) return;

  var tekstNode = wortel.querySelector('[data-gq-teksten]');
  if (!tekstNode) return;

  var T;
  try {
    T = JSON.parse(tekstNode.textContent);
  } catch (fout) {
    console.warn('Geurquiz: de teksten zijn niet te lezen.', fout);
    return;
  }

  var script = document.querySelector('script[data-index]');
  if (!script) return;

  var el = {
    stappen: {
      intro: wortel.querySelector('[data-gq-stap="intro"]'),
      vraag: wortel.querySelector('[data-gq-stap="vraag"]'),
      uitslag: wortel.querySelector('[data-gq-stap="uitslag"]'),
    },
    start: wortel.querySelector('[data-gq-start]'),
    terugval: wortel.querySelector('[data-gq-terugval]'),
    balk: wortel.querySelector('[data-gq-balk]'),
    teller: wortel.querySelector('[data-gq-teller]'),
    qbody: wortel.querySelector('[data-gq-qbody]'),
    vraag: wortel.querySelector('[data-gq-vraag]'),
    voet: wortel.querySelector('[data-gq-voet]'),
    antwoorden: wortel.querySelector('[data-gq-antwoorden]'),
    max: wortel.querySelector('[data-gq-max]'),
    terug: wortel.querySelector('[data-gq-terug]'),
    terugTekst: wortel.querySelector('[data-gq-terug-tekst]'),
    verder: wortel.querySelector('[data-gq-verder]'),
    verderTekst: wortel.querySelector('[data-gq-verder-tekst]'),
    geen: wortel.querySelector('[data-gq-geen]'),
    geenTekst: wortel.querySelector('[data-gq-geen-tekst]'),
    prev: wortel.querySelector('[data-gq-prev]'),
    prevKaarten: wortel.querySelector('[data-gq-prev-kaarten]'),
    portret: wortel.querySelector('[data-gq-portret]'),
    chips: wortel.querySelector('[data-gq-chips]'),
    melding: wortel.querySelector('[data-gq-melding]'),
    kaarten: wortel.querySelector('[data-gq-kaarten]'),
    set: wortel.querySelector('[data-gq-set]'),
    setKop: wortel.querySelector('[data-gq-set-kop]'),
    setPrijs: wortel.querySelector('[data-gq-set-prijs]'),
    setBesparing: wortel.querySelector('[data-gq-set-besparing]'),
    setKnop: wortel.querySelector('[data-gq-set-knop]'),
    status: wortel.querySelector('[data-gq-status]'),
    sticky: wortel.querySelector('[data-gq-sticky]'),
    stickyKop: wortel.querySelector('[data-gq-sticky-kop]'),
    stickyPrijs: wortel.querySelector('[data-gq-sticky-prijs]'),
    stickyKnop: wortel.querySelector('[data-gq-sticky-knop]'),
    bewaren: wortel.querySelector('[data-gq-bewaren]'),
    /* Het setblok uit design_handoff_setblok_sticky. Staat er alleen als de
     * sectie-instelling op de nieuwe stijl staat; alles hieronder is optioneel. */
    setblok: wortel.querySelector('[data-set-sectie]'),
    setblokPrijs: wortel.querySelector('[data-set-prijs]'),
    setblokVan: wortel.querySelector('[data-set-vanprijs]'),
    setblokKorting: wortel.querySelector('[data-set-korting]'),
    setblokBesparing: wortel.querySelector('[data-set-besparing]'),
    setblokKnop: wortel.querySelector('[data-set-knop]'),
  };


  /* --------------------------------------------------------------- de vragen */

  /*
   * De volgorde is bewust: makkelijk starten, het zwaarste werk in het midden,
   * makkelijk uitlopen. Vraag 3 hangt van vraag 1 en 2 af -- welke noten je te
   * zien krijgt volgt uit wat er dan nog aan kandidaten over is.
   */
  var VRAGEN = [
    { sleutel: 'v1', soort: 'enkel' },
    /*
     * min: met één familie is de kandidatenpoel smal en leunt de uitslag
     * volledig op die ene keuze. Vanaf twee heeft het model iets te wegen.
     * De waarde kan in quiz-config.json (vragen.min_families) worden
     * bijgesteld zonder aan dit bestand te komen.
     */
    { sleutel: 'v2', soort: 'meer', min: 2, max: 3, bron: 'families' },
    { sleutel: 'v3', soort: 'chips', max: 8, bron: 'noten', overslaan: true },
    { sleutel: 'v4', soort: 'meer', max: 9, bron: 'dealbreakers', overslaan: true },
    { sleutel: 'v5', soort: 'enkel' },
    { sleutel: 'v6', soort: 'enkel' },
    { sleutel: 'v7', soort: 'enkel' },
    { sleutel: 'v8', soort: 'enkel' },
  ];

  var index = null;
  var config = null;
  var antwoorden = {};
  var stap = 0;
  var meerNoten = false;
  var meerDealbreakers = false;
  var getoond = [];

  /*
   * Ruilen: wie een geur leest en denkt "toch niet", tikt op de kaart en krijgt
   * de eerstvolgende uit de ranglijst.
   *
   * rangschikking -- alle kandidaten op volgorde, uit het model
   * geweigerd     -- handles die zijn weggeruild; die komen nooit vanzelf terug,
   *                  anders staat dezelfde geur bij de volgende tik weer boven
   *                  aan de reserve en zit de klant in een lus van twee
   * historie      -- per kaartplek een stapeltje vorige geuren, voor Undo
   */
  var rangschikking = [];
  var geweigerd = [];
  var historie = {};
  var geruild = 0;

  var BEWAAR = 'sentir:geurquiz';

  /* -------------------------------------------------------------- hulpjes -- */

  function vul(tekst, waarden) {
    var uit = String(tekst || '');
    Object.keys(waarden || {}).forEach(function (sleutel) {
      uit = uit.split('[' + sleutel + ']').join(waarden[sleutel]);
    });
    return uit;
  }

  function geld(centen) {
    return '€' + (centen / 100).toFixed(2).replace('.', ',');
  }

  function leeg(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  function verborgen(tekst) {
    var span = document.createElement('span');
    span.className = 'visually-hidden';
    span.textContent = tekst + ' ';
    return span;
  }

  function toon(naam) {
    Object.keys(el.stappen).forEach(function (sleutel) {
      var node = el.stappen[sleutel];
      if (!node) return;
      node.hidden = sleutel !== naam;
      node.classList.toggle('is-active', sleutel === naam);
    });
    werkBadgeBij(naam);
  }

  /* --------------------------------------------------------------- opslaan -- */

  /*
   * Antwoorden overleven terugnavigeren én het sluiten van het tabblad. Het
   * resultaat staat bovendien in de URL, zodat het deelbaar is en in een mail
   * kan -- opnieuw scoren met dezelfde antwoorden geeft hetzelfde resultaat,
   * behalve waar de voorraad intussen veranderde.
   */
  function bewaar() {
    try {
      window.sessionStorage.setItem(BEWAAR, JSON.stringify(antwoorden));
    } catch (fout) {
      /* Privémodus; dan leven de antwoorden alleen in dit scherm. */
    }
  }

  function haalOp() {
    try {
      var ruw = window.sessionStorage.getItem(BEWAAR);
      if (ruw) return JSON.parse(ruw);
    } catch (fout) {
      /* niets */
    }
    return null;
  }

  function naarCode(a) {
    try {
      /*
       * v8 staat ACHTERAAN en niet op zijn logische plek. Een gedeelde uitslag
       * van voor deze vraag heeft zeven waarden; die leest hierdoor gewoon door
       * met v8 leeg, in plaats van dat alles een plek opschuift en iemand een
       * compleet andere uitslag te zien krijgt dan wat er gedeeld werd.
       */
      var pak = [a.v1, a.v2 || [], a.v3 || [], a.v4 || [], a.v5, a.v6, a.v7, a.v8];
      return btoa(unescape(encodeURIComponent(JSON.stringify(pak))))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
    } catch (fout) {
      return '';
    }
  }

  function uitCode(code) {
    try {
      var basis = code.replace(/-/g, '+').replace(/_/g, '/');
      var pak = JSON.parse(decodeURIComponent(escape(atob(basis))));
      return { v1: pak[0], v2: pak[1], v3: pak[2], v4: pak[3], v5: pak[4],
               v6: pak[5], v7: pak[6], v8: pak[7] };
    } catch (fout) {
      return null;
    }
  }

  /*
   * De uitslagcode in de URL zetten, maar wat er al stond laten staan. Eerst
   * gooide dit alles weg behalve het pad, en dan verdween ?view= bij het testen
   * -- ververste je dan, dan kreeg je de oude quiz terug.
   */
  function schrijfUrl() {
    var code = naarCode(antwoorden);
    if (!code || !window.history || !window.history.replaceState) return;

    var vraag = '';
    if (window.URLSearchParams) {
      var p = new window.URLSearchParams(window.location.search);
      p.set('r', code);
      vraag = '?' + p.toString();
    } else {
      vraag = '?r=' + code;
    }

    window.history.replaceState({}, '', window.location.pathname + vraag);
  }

  /* ------------------------------------------------------- de opties per vraag */

  function familieOpties() {
    return config.vragen.families_getoond.map(function (f) {
      return { waarde: f.sleutel, label: f.label, uitleg: f.voorbeelden };
    });
  }

  function dealbreakerOpties() {
    var alle = Object.keys(config.dealbreakers)
      .filter(function (k) {
        return k.charAt(0) !== '_';
      })
      .map(function (k) {
        var regel = config.dealbreakers[k];
        return { waarde: k, label: (regel && regel.label) || k };
      });

    /*
     * De lijst is gegroeid naar 24; de eerste rijen staan meteen, de rest zit
     * achter de meer-knop. Wat al aangevinkt is blijft altijd zichtbaar --
     * anders verdwijnt een keuze achter de vouw en lijkt hij kwijt.
     */
    var vouw = config.vragen.dealbreakers_zichtbaar || 0;
    if (!vouw || meerDealbreakers || alle.length <= vouw) return alle;
    var gekozen = antwoorden.v4 || [];
    return alle.filter(function (o, i) {
      return i < vouw || gekozen.indexOf(o.waarde) > -1;
    });
  }

  /*
   * De notenchips zijn gefilterd op wat er in de kandidatenset zit, en gesorteerd
   * op hoe vaak ze daar voorkomen. Zonder dat filter kiest iemand een noot
   * waarvoor nul geuren bestaan, en dan is de uitslag leeg door zijn eigen
   * antwoord zonder dat hij begrijpt waarom.
   */
  function nootOpties() {
    /* index.voorraad bestaat alleen op de live bron. Het gebouwde bestand kent
     * geen voorraad, en dan filtert het model er niet op -- beter dan filteren
     * op een voorraadstand van vorige week. */
    var kandidaten = window.SentirGeurModel.filter(index.geuren, antwoorden, config, {
      voorraad: index.voorraad,
    });

    var families = antwoorden.v2 || [];
    if (families.length) {
      kandidaten = kandidaten.filter(function (g) {
        return g.families.some(function (f) {
          return families.indexOf(f) > -1;
        });
      });
    }

    /*
     * Sommige noten laten we niet zien. Niet omdat ze niet bestaan, maar omdat
     * niemand ze kent -- een klant die "Reseda" leest, leert daar niets van en
     * klikt hem niet aan. Ze blijven wel meetellen in de score als iemand een
     * verwante noot kiest; ze staan alleen niet in de lijst.
     */
    var verborgenNoten = {};
    (config.vragen.noten_verborgen || []).forEach(function (n) {
      verborgenNoten[String(n).toLowerCase()] = true;
    });

    var telling = {};
    kandidaten.forEach(function (g) {
      [].concat(g.notenTop, g.notenHart, g.notenBasis).forEach(function (n) {
        if (verborgenNoten[String(n).toLowerCase()]) return;
        telling[n] = (telling[n] || 0) + 1;
      });
    });

    /*
     * De chips horen bij de families die de bezoeker net koos.
     *
     * Sorteren op hoe vaak een noot voorkomt gaf bij elke familie bijna
     * hetzelfde rijtje -- aquatisch en citrus deelden zeventien van de twintig --
     * omdat vanille, amber, bergamot en jasmijn nu eenmaal in bijna elk parfum
     * zitten. Wie geen bloemig koos kreeg alsnog roos en jasmijn.
     *
     * Andersom rekenen, op hoe typerend een noot is voor de kandidaten, deed het
     * omgekeerde: dan vielen sandelhout en ceder eruit bij houtachtig, want die
     * zitten óók overal. Met 115 parfums zijn die verhoudingen te wankel.
     *
     * Daarom staat het gewoon opgeschreven in quiz-config.json: welke noot bij
     * welke familie hoort. Geen berekening, een lijst.
     */
    var perFamilie = config.vragen.noten_familie || {};

    /*
     * Een noot mag bij MEER dan een familie horen (waarde is dan een lijstje).
     * Vanille is daar het schoolvoorbeeld: thuis bij Gourmand, maar hij zit in
     * 53 van de 115 parfums en iedereen die Amber kiest verwacht hem ook. Met
     * een enkele thuisfamilie was hij onzichtbaar in alle vier de populairste
     * familiecombinaties uit de data-analyse.
     */
    function hoortErbij(n) {
      var f = perFamilie[n];
      if (!f) return false;
      var lijst = [].concat(f);
      for (var i = 0; i < lijst.length; i += 1) {
        if (families.indexOf(lijst[i]) > -1) return true;
      }
      return false;
    }

    var opAantal = function (a, b) {
      return telling[b] - telling[a] || a.localeCompare(b);
    };

    var passend = Object.keys(telling).filter(hoortErbij).sort(opAantal);
    var grens = meerNoten ? config.vragen.noten_uitgeklapt : config.vragen.noten_zichtbaar;

    /*
     * Levert het te weinig op -- een smalle keuze, of noten die nog niet in de
     * lijst staan -- dan vullen we aan met de rest op aantal. Liever een paar
     * algemene chips erbij dan een half scherm.
     */
    var minimaal = Math.min(grens, config.vragen.noten_minimum || 10);
    if (passend.length < minimaal) {
      Object.keys(telling)
        .filter(function (n) { return !hoortErbij(n); })
        .sort(opAantal)
        .forEach(function (n) { if (passend.length < minimaal) passend.push(n); });
    }

    return passend.slice(0, grens).map(function (n) {
      return { waarde: n, label: index.notenNamen[n] || n };
    });
  }

  function optiesVoor(vraag) {
    if (vraag.bron === 'families') return familieOpties();
    if (vraag.bron === 'dealbreakers') return dealbreakerOpties();
    if (vraag.bron === 'noten') return nootOpties();
    return (T.vragen[vraag.sleutel] || {}).opties || [];
  }

  /* -------------------------------------------------------------- tekenen -- */

  /* Vragen 2, 3 en 4 hebben een subregel en mogen wat dichter op elkaar. */
  var VOL = { v2: true, v3: true, v4: true };

  /*
   * zelfdeVraag: de vraag wordt opnieuw getekend zonder dat de bezoeker van
   * vraag wisselt (de notenlijst uitklappen). Dan geen focus op de kop --
   * focus laat mobiel naar de kop scrollen, en dan schiet het beeld omhoog
   * terwijl de bezoeker net onderaan aan het kiezen was.
   */
  function tekenVraag(zelfdeVraag) {
    var vraag = VRAGEN[stap];
    var teksten = T.vragen[vraag.sleutel] || {};

    el.balk.style.width = Math.round(((stap + 1) / VRAGEN.length) * 100) + '%';
    el.teller.textContent = vul(T.voortgang, { nu: stap + 1, totaal: VRAGEN.length });
    el.terugTekst.textContent = T.terug;
    el.terug.classList.toggle('is-hidden', stap === 0);

    el.qbody.classList.toggle('is-tight', Boolean(VOL[vraag.sleutel]));

    el.vraag.textContent = teksten.vraag || '';
    /*
     * Zonder subregel reserveert de kop zelf de ruimte die zo'n regel inneemt.
     * Anders schuiven de antwoorden per vraag omhoog en omlaag, en dat is
     * precies wat dit ontwerp wil voorkomen.
     */
    var heeftVoet = Boolean(teksten.voet) || vraag.soort !== 'enkel';
    el.vraag.classList.toggle('is-solo', !heeftVoet);
    el.voet.hidden = !heeftVoet;
    el.voet.textContent = teksten.voet || (vraag.max ? vul(T.maxMelding, { max: vraag.max }) : '');

    el.max.textContent = '';
    el.max.classList.remove('is-hot');

    var opties = optiesVoor(vraag);
    leeg(el.antwoorden);

    if (vraag.bron === 'families') tekenTegels(vraag, opties);
    else if (vraag.soort === 'enkel') tekenRijen(vraag, opties);
    else tekenChips(vraag, opties);

    var meervoud = vraag.soort !== 'enkel';
    el.verder.hidden = !meervoud;
    if (meervoud) {
      var gekozen = (antwoorden[vraag.sleutel] || []).length;
      el.verderTekst.textContent = gekozen || !vraag.overslaan ? T.verder : T.overslaan;
    }

    /* Alleen bij de dealbreakers, en visueel duidelijk geen tiende optie. */
    var toonGeen = vraag.bron === 'dealbreakers';
    el.geen.hidden = !toonGeen;
    if (toonGeen) el.geenTekst.textContent = (T.vragen.v4 || {}).geen || T.overslaan;

    if (!zelfdeVraag) el.vraag.focus();
  }

  function kiesEnkel(vraag, waarde, knop) {
    antwoorden[vraag.sleutel] = waarde;
    knop.classList.add('is-on');
    /* De vulling ís de overgang -- bij zeven vragen wordt elke extra animatie
     * een vertraging. Even laten staan, dan door. */
    window.setTimeout(verder, 180);
  }

  function wisselMeer(vraag, waarde) {
    var lijst = antwoorden[vraag.sleutel] || [];
    var positie = lijst.indexOf(waarde);

    if (positie > -1) {
      lijst.splice(positie, 1);
    } else {
      if (vraag.max && lijst.length >= vraag.max) {
        /* Niet stil negeren: dat leest als een kapotte knop. */
        el.max.textContent = vul(T.maxMelding, { max: vraag.max });
        el.max.classList.remove('is-hot');
        void el.max.offsetWidth;
        el.max.classList.add('is-hot');
        return false;
      }
      lijst.push(waarde);
    }

    antwoorden[vraag.sleutel] = lijst;
    el.max.textContent = '';
    el.max.classList.remove('is-hot');
    bewaar();
    return true;
  }

  /*
   * Na het aan- of uitzetten van een keuze hoeft alleen het knoplabel onderaan
   * mee ("Volgende" of "Overslaan"). De hele vraag opnieuw tekenen -- wat hier
   * eerst gebeurde -- gooide alle negen fototegels weg en bouwde ze opnieuw,
   * en zette daarna focus op de kop: het beeld schoot omhoog bij elke tik.
   */
  function werkVerderBij(vraag) {
    if (vraag.soort === 'enkel' || !el.verderTekst) return;
    var gekozen = (antwoorden[vraag.sleutel] || []).length;
    el.verderTekst.textContent = gekozen || !vraag.overslaan ? T.verder : T.overslaan;
  }

  function gekozenIn(vraag, waarde) {
    var huidig = antwoorden[vraag.sleutel];
    return vraag.soort === 'enkel'
      ? huidig === waarde
      : (huidig || []).indexOf(waarde) > -1;
  }

  /* --- soort 1: rijen, bij drie antwoorden --- */
  function tekenRijen(vraag, opties) {
    var lijst = document.createElement('div');
    lijst.className = 'gq-opts';

    opties.forEach(function (optie) {
      var knop = document.createElement('button');
      knop.type = 'button';
      knop.className = 'gq-opt' + (gekozenIn(vraag, optie.waarde) ? ' is-on' : '');
      knop.setAttribute('aria-pressed', String(gekozenIn(vraag, optie.waarde)));

      var icoon = icoonVoor(optie.waarde);
      if (icoon) {
        var svg = maakSvg(icoon);
        svg.classList.add('gq-ic');
        knop.appendChild(svg);
      }

      var tekst = document.createElement('span');
      tekst.className = 'gq-opt-tekst';
      var naam = document.createElement('b');
      naam.textContent = optie.label;
      tekst.appendChild(naam);
      if (optie.uitleg) {
        var uitleg = document.createElement('em');
        uitleg.textContent = optie.uitleg;
        tekst.appendChild(uitleg);
      }
      knop.appendChild(tekst);

      var vink = maakSvg(LUCIDE.check);
      vink.classList.add('gq-ck');
      knop.appendChild(vink);

      knop.addEventListener('click', function () {
        kiesEnkel(vraag, optie.waarde, knop);
      });

      lijst.appendChild(knop);
    });

    el.antwoorden.appendChild(lijst);
  }

  /* --- soort 2: fototegels, bij de negen geurfamilies --- */
  function tekenTegels(vraag, opties) {
    var raster = document.createElement('div');
    raster.className = 'gq-ptiles';

    opties.forEach(function (optie) {
      var foto = (T.familieFotos || {})[optie.waarde];

      var knop = document.createElement('button');
      knop.type = 'button';
      knop.className =
        'gq-ptile' + (foto ? '' : ' gq-ptile--leeg') + (gekozenIn(vraag, optie.waarde) ? ' is-on' : '');
      knop.setAttribute('aria-pressed', String(gekozenIn(vraag, optie.waarde)));

      if (foto) {
        var img = document.createElement('img');
        /* Een string blijft werken; een object levert twee breedtes. */
        if (typeof foto === 'string') {
          img.src = foto;
        } else {
          img.src = foto.groot;
          if (foto.klein) {
            img.srcset = foto.klein + ' 360w, ' + foto.groot + ' 560w';
            img.sizes = '(min-width: 750px) 220px, 45vw';
          }
        }
        img.alt = '';
        /*
         * Niet lazy: alle negen staan tegelijk in beeld, en dan kost lui laden
         * alleen maar een leeg vlak op het moment dat de vraag verschijnt.
         */
        img.decoding = 'async';
        knop.appendChild(img);
      }

      var vlak = document.createElement('span');
      vlak.className = 'gq-pt-t';
      var naam = document.createElement('b');
      naam.textContent = optie.label;
      vlak.appendChild(naam);
      if (optie.uitleg) {
        var voorbeelden = document.createElement('em');
        voorbeelden.textContent = optie.uitleg;
        vlak.appendChild(voorbeelden);
      }
      knop.appendChild(vlak);

      var vink = maakSvg(LUCIDE.check);
      vink.classList.add('gq-ck');
      knop.appendChild(vink);

      knop.addEventListener('click', function () {
        if (!wisselMeer(vraag, optie.waarde)) return;
        var aan = gekozenIn(vraag, optie.waarde);
        knop.classList.toggle('is-on', aan);
        knop.setAttribute('aria-pressed', String(aan));
        werkVerderBij(vraag);
      });

      raster.appendChild(knop);
    });

    el.antwoorden.appendChild(raster);
  }

  /* --- soort 3: chips, bij de noten en de dealbreakers --- */
  function tekenChips(vraag, opties) {
    var rij = document.createElement('div');
    rij.className = 'gq-nchips';

    opties.forEach(function (optie) {
      var aan = gekozenIn(vraag, optie.waarde);
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'gq-nchip' + (aan ? ' is-on' : '');
      chip.setAttribute('aria-pressed', String(aan));
      chip.textContent = optie.label;

      /*
       * Bij de noten krijgt elke chip de kleur van zijn familie -- dezelfde
       * pastels als de stijlpillen op de uitslag, zodat quiz en uitslag één
       * taal spreken. Bij de dealbreakers niet: dat is een uitsluitlijst, geen
       * geurpalet.
       */
      if (vraag.bron === 'noten') {
        var familie = notenFamilie(optie.waarde);
        var kleur = familie && config.palet.families[familie];
        if (kleur) {
          chip.style.background = kleur.bg;
          chip.style.color = kleur.fg;
          chip.style.borderColor = 'transparent';
        }
      }

      chip.addEventListener('click', function () {
        if (!wisselMeer(vraag, optie.waarde)) return;
        /* De is-on-stijl wint met !important van de inline familiekleur. */
        var nu = gekozenIn(vraag, optie.waarde);
        chip.classList.toggle('is-on', nu);
        chip.setAttribute('aria-pressed', String(nu));
        werkVerderBij(vraag);
      });

      rij.appendChild(chip);
    });

    var toonMeer = null;
    if (vraag.bron === 'noten' && !meerNoten) {
      toonMeer = function () { meerNoten = true; };
    } else if (
      vraag.bron === 'dealbreakers' &&
      !meerDealbreakers &&
      (config.vragen.dealbreakers_zichtbaar || 0) > 0 &&
      opties.length < Object.keys(config.dealbreakers).filter(function (k) { return k.charAt(0) !== '_'; }).length
    ) {
      /* Zelfde knop als bij de noten, maar dan voor de gevouwen dealbreakers. */
      toonMeer = function () { meerDealbreakers = true; };
    }

    if (toonMeer) {
      var meer = document.createElement('button');
      meer.type = 'button';
      meer.className = 'gq-more';
      meer.appendChild(document.createTextNode(
        vraag.bron === 'dealbreakers' ? T.meerDealbreakers || T.meerNoten : T.meerNoten
      ));
      meer.appendChild(maakSvg(LUCIDE.chevronDown));
      meer.addEventListener('click', function () {
        toonMeer();
        /* Zelfde vraag, dus zonder focus op de kop -- anders schiet het beeld
         * omhoog terwijl de bezoeker net bij de lijst was. */
        tekenVraag(true);
      });
      rij.appendChild(meer);
    }

    el.antwoorden.appendChild(rij);
  }

  function verder() {
    /*
     * Een vraag met een minimum laat je niet door voordat dat er staat. Zelfde
     * meldingsregel als bij het maximum: kort oplichten, niet stil negeren.
     */
    var huidige = VRAGEN[stap];
    if (huidige && huidige.min) {
      var aantal = (antwoorden[huidige.sleutel] || []).length;
      if (aantal < huidige.min) {
        el.max.textContent = vul(T.minMelding, { min: huidige.min });
        el.max.classList.remove('is-hot');
        void el.max.offsetWidth;
        el.max.classList.add('is-hot');
        return;
      }
    }

    bewaar();
    /*
     * Vraag 3 hangt af van 1 en 2, dus de gekozen noten kunnen na een wijziging
     * niet meer bestaan. Die halen we eruit in plaats van ze te laten staan als
     * onzichtbare voorkeur.
     */
    if (stap === 1) {
      var geldig = nootOpties().map(function (o) {
        return o.waarde;
      });
      antwoorden.v3 = (antwoorden.v3 || []).filter(function (n) {
        return geldig.indexOf(n) > -1;
      });
    }

    stap += 1;
    if (stap >= VRAGEN.length) {
      afronden(true);
      return;
    }
    tekenVraag();
  }

  el.verder.addEventListener('click', verder);

  if (el.geen) {
    el.geen.addEventListener('click', function () {
      antwoorden.v4 = [];
      bewaar();
      verder();
    });
  }
  el.terug.addEventListener('click', function () {
    if (stap === 0) return;
    stap -= 1;
    tekenVraag();
  });

  /* -------------------------------------------------------------- uitslag -- */

  function labelVan(sleutel, waarde) {
    var opties = (T.vragen[sleutel] || {}).opties || [];
    for (var i = 0; i < opties.length; i += 1) {
      if (opties[i].waarde === waarde) return opties[i].label;
    }
    return waarde;
  }

  function sillageLabel(sleutel) {
    var tabel = (config.vragen && config.vragen.sillage_labels) || {};
    return tabel[sleutel] || sleutel;
  }

  function familieLabel(sleutel) {
    var gevonden = config.vragen.families_getoond.filter(function (f) {
      return f.sleutel === sleutel;
    })[0];
    return gevonden ? gevonden.label : sleutel;
  }

  function nootLabel(sleutel) {
    return (index.notenNamen && index.notenNamen[sleutel]) || sleutel;
  }

  /*
   * "a, b en c" en niet "a en b en c". Het voegwoord komt uit de instellingen,
   * want dit bestand mag geen taal bevatten -- de winkel schrijft Engels en
   * Weglot doet de rest.
   */
  function opsomming(lijst) {
    var delen = (lijst || []).filter(Boolean);
    if (delen.length < 2) return delen.join('');
    return delen.slice(0, -1).join(', ') + ' ' + (T.voegwoord || 'and') + ' ' + delen[delen.length - 1];
  }

  /*
   * Het portret. Niet één zin met gaten erin -- dat werd "draagt het vooral
   * allebei ongeveer evenveel", en dan snapt niemand waar "allebei" op slaat.
   * Nu drie korte zinnen die elk één ding zeggen, opgebouwd uit losse stukjes
   * die allemaal in de theme editor staan: hoe je geur voelt, waar je naar
   * grijpt, en wanneer en hoe hard hij mag spreken.
   */
  function portret() {
    var p = T.portret || {};
    var zinnen = [];

    var warmte = { Warm: p.warm, Fris: p.fris, Wisselt: p.seizoen }[antwoorden.v7];
    if (warmte) zinnen.push(warmte);

    var noten = (antwoorden.v3 || []).slice(0, 3).map(nootLabel);
    if (noten.length && p.noten) {
      zinnen.push(vul(p.noten, { noten: opsomming(noten) }));
    } else if ((antwoorden.v2 || []).length && p.families) {
      zinnen.push(vul(p.families, { families: opsomming((antwoorden.v2 || []).map(familieLabel)) }));
    }

    /*
     * Moment en aanwezigheid horen in één zin: apart lezen ze als twee losse
     * mededelingen, samen zeggen ze hoe iemand gedragen wil worden.
     */
    var moment = { Dag: p.overdag, Avond: p.avond, Beide: p.altijd }[antwoorden.v6] || '';
    var kracht =
      { Ruimtevullend: p.groot, Aanwezig: p.merkbaar, Intiem: p.dichtbij }[antwoorden.v5] || '';
    var derde = (moment + ' ' + kracht).trim();
    if (derde) zinnen.push(derde);

    return zinnen.join(' ');
  }

  /*
   * echt=true betekent: iemand heeft de zeven vragen zojuist zelf doorlopen.
   * Een gedeelde uitslaglink (?r=) en een hervatte sessie tekenen dezelfde
   * uitslag, maar dat zijn géén voltooiingen -- zonder dit onderscheid telde
   * elke ontvanger van een gedeelde link als een nieuwe invuller, en dan meet
   * je populariteit van de link in plaats van van de quiz.
   */
  function afronden(echt) {
    var uitslag = window.SentirGeurModel.adviseer({
      geuren: index.geuren,
      config: config,
      antwoorden: antwoorden,
      notenNamen: index.notenNamen,
      /* Uitverkocht aanraden is de ene fout die de klant meteen ziet. Live
       * weten we de stand; uit het bestand niet, en dan blijft dit leeg. */
      voorraad: index.voorraad,
      verkenning: verkenningInstel(),
    });

    /* Welke geur de wildcard was (of null), voor het stempel op de meting. */
    verkendHandle = uitslag.verkend || null;

    getoond = uitslag.set;

    /* Elke nieuwe uitslag begint met een schone lei aan ruilingen. */
    rangschikking = uitslag.gerangschikt || [];
    geweigerd = [];
    historie = {};
    geruild = 0;

    toon('uitslag');
    toonUitslag(true);
    schrijfUrl();
    bewaar();

    portretMetPillen(el.portret, portret());
    chipsVoor(el.chips);

    if (!uitslag.set.length) {
      el.melding.textContent = T.uitslag.leeg;
    } else if (uitslag.onvolledig) {
      el.melding.textContent = vul(T.uitslag.onvolledig, { aantal: uitslag.set.length });
    } else {
      el.melding.textContent = '';
    }

    var procent = procentVoor(uitslag.set.length);
    leeg(el.kaarten);
    uitslag.set.forEach(function (k, i) {
      el.kaarten.appendChild(kaartVoor(k, i + 1, procent));
    });

    tekenSet(uitslag.set);
    naarKlaviyo(uitslag.set, echt);

    /*
     * Het mandje meteen bij de uitslag merken, niet pas bij de setknop: wie
     * naar een productpagina doorklikt en dáár toevoegt, draagt zijn sessie
     * dan ook. En zo bestaat het mandje (mét cookie) al voordat add.js
     * vertrekt, wat de race hieronder in voegToe ook in oude sessies smoort.
     */
    merkMandje();

    gelijkeKaarthoogtes();
    startAnimatie();
    startDock();
    laadStampedBadges();

    el.portret.focus();
  }

  /*
   * De openingsanimatie (results-intro.js) leest de uitslag één keer en meet dan
   * waar de regels van het portret breken en welke kaarten boven de vouw staan.
   * Dat kan pas als de kaarten er staan en de sectie zichtbaar is -- als los
   * <script defer> zou het een lege, verborgen sectie meten. Vandaar dat het
   * hier wordt ingeladen, na de laatste keer tekenen.
   *
   * Twee frames wachten: één om de nieuwe kaarten te laten opmaken, één zodat
   * getBoundingClientRect echte posities teruggeeft.
   */
  var animatieGeladen = false;
  var dockGeladen = false;

  /*
   * set-dock.js meet bij het starten hoe hoog de uitgeklapte kaart is, om die
   * plek in de pagina te reserveren. Zolang het uitslagscherm nog verborgen is,
   * meet het nul. Vandaar dat het net als de openingsanimatie pas wordt geladen
   * als de kaarten er staan -- en pas na twee frames, zodat de opmaak klaar is.
   */
  function startDock() {
    if (dockGeladen) return;
    var bron = script && script.dataset ? script.dataset.dock : null;
    if (!bron || !el.setblok) return;
    dockGeladen = true;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var s = document.createElement('script');
        s.src = bron;
        /*
         * Laadt het niet, dan blijft de kaart gewoon uitgeklapt in de pagina
         * staan. Dat is precies de terugval die de handoff beschrijft: zonder
         * script gebeurt er niets en werkt de knop nog steeds.
         */
        document.head.appendChild(s);
      });
    });
  }

  function startAnimatie() {
    if (animatieGeladen) return;
    var bron = script && script.dataset ? script.dataset.anim : null;
    if (!bron) return;
    animatieGeladen = true;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var s = document.createElement('script');
        s.src = bron;
        /*
         * Gaat het laden mis, dan haalt de CSS het portret nooit uit
         * visibility:hidden. Dan liever geen animatie dan een halve pagina.
         */
        s.onerror = function () {
          var wortel = document.querySelector('[data-results-anim]');
          if (wortel) wortel.removeAttribute('data-results-anim');
        };
        document.head.appendChild(s);
      });
    });
  }

  /*
   * De uitslag is geen quizvraag: hij mag groeien en hoeft niet gecentreerd. De
   * beeldvullende hoogte zit op de buitenste laag, dus daar zet deze klasse hem
   * weer uit.
   */
  function toonUitslag(aan) {
    wortel.classList.toggle('gq--uitslag', Boolean(aan));
  }

  /*
   * De geuriconen, letterlijk uit het bronprototype (ICONS in
   * explorations/Parfumquiz.html). Niet natekenen: ze horen bij het palet.
   */
  /*
   * Functionele iconen uit de Lucide-set, letterlijk. Niet natekenen: de paden
   * wijken subtiel af en dat valt op -- clock heeft r=10, niet r=9.
   */
  var LUCIDE = {
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>',
    chevronDown: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>',
    venus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 15v7"/><path d="M9 19h6"/><circle cx="12" cy="9" r="6"/></svg>',
    mars: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M16 3h5v5"/><path d="m21 3-6.75 6.75"/><circle cx="10" cy="14" r="6"/></svg>',
    beide: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M10 20h4"/><path d="M12 16v6"/><path d="M17 2h4v4"/><path d="m21 2-5.46 5.46"/><circle cx="12" cy="11" r="5"/></svg>',
    sun: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/></svg>',
    moon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"/></svg>',
    rotate: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>',
  };

  /*
   * Welk icoon bij welk antwoord. Vraag 1 krijgt gendertekens en geen bloem of
   * ringen -- dat gaat over de klant, niet over de geur. De rest leunt op het
   * geurpalet.
   */
  var ANTWOORD_ICOON = {
    haar: LUCIDE.venus, hem: LUCIDE.mars, alles: LUCIDE.beide,
    Ruimtevullend: 'burst', Aanwezig: 'sparkle', Intiem: 'feather',
    Dag: LUCIDE.sun, Avond: LUCIDE.moon, Beide: LUCIDE.rotate,
    Warm: 'pod', Fris: 'droplet', Wisselt: LUCIDE.rotate,
  };

  function icoonVoor(waarde) {
    var bron = ANTWOORD_ICOON[waarde];
    if (!bron) return null;
    return ICONEN[bron] || bron;
  }

  var ICONEN = {
    droplet: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11z"/></svg>',
    citrus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="8"/><path d="M12 4v16M5.1 8l13.8 8M5.1 16l13.8-8"/></svg>',
    leaf: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 20C5 11 11 5 20 4c0 9-6 15-15 16z"/><path d="M5 20C9 15 13 11 18 7"/></svg>',
    pod: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 17c5 5 13 1 16-9-7-2-14 1-16 9z"/><path d="M6 16c4-3 8-5 12-6"/></svg>',
    sparkle: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M12 3l2.2 6.8L21 12l-6.8 2.2L12 21l-2.2-6.8L3 12l6.8-2.2L12 3z"/></svg>',
    flower: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="2.4"/><circle cx="12" cy="5.6" r="2.6"/><circle cx="18" cy="9.8" r="2.6"/><circle cx="15.8" cy="16.8" r="2.6"/><circle cx="8.2" cy="16.8" r="2.6"/><circle cx="6" cy="9.8" r="2.6"/></svg>',
    rings: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="4.6"/><circle cx="12" cy="12" r="1.4"/></svg>',
    burst: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 4v16M4 12h16M6.3 6.3l11.4 11.4M17.7 6.3L6.3 17.7"/></svg>',
    cherry: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8.5" cy="16.5" r="3.5"/><circle cx="16" cy="15.5" r="3.5"/><path d="M8.5 13C9 9 12 5.5 17 4M16 12c-.5-3.5 0-6 1-8"/></svg>',
    feather: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 4C12 4 6 10 4 20c10-2 16-8 16-16z"/><path d="M5 19L18 6"/></svg>',
    wave: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M3 9.5c2.5-2.5 5-2.5 7.5 0s5 2.5 7.5 0M3 15.5c2.5-2.5 5-2.5 7.5 0s5 2.5 7.5 0"/></svg>',
    coco: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="8"/><circle cx="9.7" cy="10.2" r="1" fill="currentColor" stroke="none"/><circle cx="14.3" cy="10.2" r="1" fill="currentColor" stroke="none"/><circle cx="12" cy="14" r="1" fill="currentColor" stroke="none"/></svg>',
    smoke: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M9 20c-2-2.5 2-4.5 0-7s2-4.5 0-7"/><path d="M15 20c-2-2.5 2-4.5 0-7s2-4.5 0-7"/></svg>',
  };

  /* -------------------------------------------------------------- uitslag -- */

  var STUKPRIJS_TERUGVAL = 1495;

  /* De staffel komt uit het winkelmandje; zie [data-sentir-tiers]. */
  function staffel() {
    var node = document.querySelector('[data-sentir-tiers]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (fout) {
      return null;
    }
  }

  function procentVoor(aantal) {
    var s = staffel();
    if (!s || !s.tiers) return 0;
    if (aantal >= 4) return s.tiers['4'] || 0;
    if (aantal === 3) return s.tiers['3'] || 0;
    if (aantal === 2) return s.tiers['2'] || 0;
    return 0;
  }

  function maakSvg(bron) {
    var houder = document.createElement('span');
    /*
     * Deze SVG's zijn constanten uit dit bestand, geen invoer van buiten. Dat
     * is de enige reden dat innerHTML hier mag.
     */
    houder.innerHTML = bron;
    return houder.firstElementChild;
  }

  function elementje(tag, klasse, tekst) {
    var node = document.createElement(tag);
    if (klasse) node.className = klasse;
    if (tekst !== undefined && tekst !== null) node.textContent = tekst;
    return node;
  }

  /*
   * De noten die de bezoeker koos en die in het portret voorkomen, krijgen de
   * kleur van hun geurfamilie. Vind je geen match, dan blijft het platte tekst
   * -- niet raden.
   */
  function portretMetPillen(doel, zin) {
    leeg(doel);

    var gekozen = (antwoorden.v3 || [])
      .map(function (sleutel) {
        var naam = nootLabel(sleutel);
        var familie = notenFamilie(sleutel);
        var kleur = familie && config.palet.families[familie];
        return kleur ? { naam: naam, kleur: kleur } : null;
      })
      .filter(Boolean)
      .sort(function (a, b) {
        return b.naam.length - a.naam.length;
      });

    if (!gekozen.length) {
      doel.textContent = zin;
      return;
    }

    var patroon = new RegExp(
      '(' + gekozen.map(function (g) { return g.naam.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|') + ')',
      'gi'
    );

    zin.split(patroon).forEach(function (deel, i) {
      if (i % 2 === 0) {
        if (deel) doel.appendChild(document.createTextNode(deel));
        return;
      }
      var raak = gekozen.filter(function (g) {
        return g.naam.toLowerCase() === deel.toLowerCase();
      })[0];
      var pil = elementje('span', 'gq-kw', deel);
      if (raak) {
        pil.style.background = raak.kleur.bg;
        pil.style.color = raak.kleur.fg;
      }
      doel.appendChild(pil);
    });
  }

  /* Welke geurfamilie hoort bij een noot? Via de geuren waarin hij voorkomt. */
  function notenFamilie(sleutel) {
    for (var i = 0; i < index.geuren.length; i += 1) {
      var g = index.geuren[i];
      var raak =
        g.notenBasis.indexOf(sleutel) > -1 ||
        g.notenHart.indexOf(sleutel) > -1 ||
        g.notenTop.indexOf(sleutel) > -1;
      if (raak && g.stijlen && g.stijlen[0] && g.stijlen[0].familie) return g.stijlen[0].familie;
    }
    return null;
  }

  function chipsVoor(doel) {
    leeg(doel);

    []
      .concat(
        [labelVan('v1', antwoorden.v1)],
        (antwoorden.v2 || []).map(familieLabel),
        [labelVan('v5', antwoorden.v5), labelVan('v6', antwoorden.v6)]
      )
      .filter(Boolean)
      .forEach(function (tekst) {
        var chip = elementje('span', 'gq-chip', tekst);
        chip.setAttribute('data-anim', 'chip');
        doel.appendChild(chip);
      });

    /*
     * Eén weg terug, niet twee. Een losse "opnieuw"-link deed vrijwel hetzelfde
     * en verwarde alleen.
     */
    var wijzig = elementje('button', 'gq-chip-edit', T.uitslag.aanpassen);
    wijzig.type = 'button';
    wijzig.setAttribute('data-anim', 'chip-edit');
    wijzig.addEventListener('click', function () {
      stap = 0;
      toonUitslag(false);
      toon('vraag');
      tekenVraag();
    });
    doel.appendChild(wijzig);
  }

  /* ---------------------------------------------------------------- kaarten */

  function prijsPerStuk(procent, prijs) {
    return Math.round((prijs * (100 - procent)) / 100);
  }

  /* ---------------------------------------------------------------- ruilen -- */

  function rustig() {
    return (
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  /*
   * De eerstvolgende die de plek kan innemen: hoogste in de ranglijst die niet
   * al ergens op het scherm staat en niet eerder is weggeruild.
   *
   * Geen familie- of spreidingsregel hier. Die horen bij het samenstellen van de
   * eerste set; kiest de klant zélf om te ruilen, dan wil hij de best passende
   * volgende en geen geur die alleen maar anders is.
   */
  function volgende() {
    var opDeStoep = {};
    getoond.forEach(function (k) { opDeStoep[k.geur.handle] = true; });
    geweigerd.forEach(function (h) { opDeStoep[h] = true; });

    for (var i = 0; i < rangschikking.length; i += 1) {
      if (!opDeStoep[rangschikking[i].geur.handle]) return rangschikking[i];
    }
    return null;
  }

  function erIsNogWat() {
    return volgende() !== null;
  }

  /*
   * Eén kaart vervangen. `nieuw` is de kandidaat die de plek inneemt; bij Undo
   * komt die uit de historie in plaats van uit de ranglijst.
   *
   * De plek wordt op het klikmoment opgezocht en niet uit de closure gehaald:
   * er kan intussen elders geruild zijn, en dan zou dit de verkeerde kaart
   * vervangen -- en de setknop de verkeerde geur verkopen.
   */
  function vervang(li, nieuw, terug) {
    var i = Array.prototype.indexOf.call(el.kaarten.children, li);
    if (i < 0 || !nieuw) return;

    var oud = getoond[i];

    if (terug) {
      /* Undo: de weggeruilde mag weer meedoen. */
      var plek = geweigerd.indexOf(nieuw.geur.handle);
      if (plek > -1) geweigerd.splice(plek, 1);
    } else {
      geweigerd.push(oud.geur.handle);
      (historie[i] = historie[i] || []).push(oud);
      geruild += 1;
    }

    nieuw.redenen = window.SentirGeurModel.redenen(nieuw, antwoorden, config);
    getoond[i] = nieuw;

    /*
     * Stond het uitklappaneel open, dan hoort het open te blijven -- anders
     * klapt de kaart onder de ogen van de klant dicht terwijl hij juist meer
     * wilde weten.
     */
    var stondOpen = !!li.querySelector('.gq-pdetail.is-open');

    var hoog = li.offsetHeight;
    var vers = kaartVoor(nieuw, i + 1, procentVoor(getoond.length));
    if (stondOpen) {
      vers.querySelector('.gq-pdetail').classList.add('is-open');
      var chevron = vers.querySelector('.gq-pcard-toggle');
      chevron.classList.add('is-open');
      chevron.setAttribute('aria-expanded', 'true');
    }

    el.kaarten.replaceChild(vers, li);

    /*
     * De hoogte vastzetten over de wissel heen. Kaarten verschillen in hoogte --
     * wel of geen korte tekst, wel of geen stijlpillen -- en zonder dit springt
     * alles eronder weg precies op het moment dat de klant kijkt.
     */
    if (!rustig()) {
      var nieuwHoog = vers.offsetHeight;
      vers.classList.add('gq-wisselt');
      vers.style.height = hoog + 'px';
      /* Een gedwongen meting, anders ziet de browser alleen de eindwaarde. */
      void vers.offsetHeight;
      vers.style.height = nieuwHoog + 'px';
      window.setTimeout(function () {
        vers.style.height = '';
        vers.classList.remove('gq-wisselt');
      }, 300);
    }

    /* De setknop en de balk rekenen met de nieuwe geuren. */
    tekenSet(getoond);
    merkMandje();

    var L = T.uitslag;
    melden(vul(L.ruilMelding, { nummer: i + 1, geur: nieuw.geur.titel }));

    if (!terug) {
      meet(NAMEN.geruild, {
        Positie: i + 1,
        Weg: oud.geur.titel,
        Nieuw: nieuw.geur.titel,
        Ruil_nummer: geruild,
      });
    }

    /*
     * De knop waar net op geklikt is bestaat niet meer. Zonder dit valt de focus
     * terug op <body> en begint een toetsenbordgebruiker elke ruil weer bovenaan
     * de pagina.
     */
    gelijkeKaarthoogtes();
    laadStampedBadges();

    var volgKnop = vers.querySelector('[data-gq-ruil]:not([disabled])') ||
                   vers.querySelector('[data-gq-ruil-terug]') ||
                   vers.querySelector('[data-gq-los]');
    if (volgKnop) volgKnop.focus();
  }

  /*
   * Op desktop staan de kaarten twee-aan-twee en horen ze in rust even hoog te
   * zijn. Dat deed eerst het raster (stretch), maar dan rekt de buurman mee
   * zodra één kaart zijn uitklap opent. Nu meet dit de hoogste DICHTE kaart en
   * zet die als min-height op allemaal: gelijk in rust, en een open uitklap
   * laat alleen zijn eigen kaart groeien.
   */
  var kaartMinHoogte = 0;

  function gelijkeKaarthoogtes() {
    if (!el.kaarten) return;
    var kaarten = [];
    for (var i = 0; i < el.kaarten.children.length; i += 1) {
      var k = el.kaarten.children[i].querySelector('.gq-pcard');
      if (k) kaarten.push(k);
    }
    if (!kaarten.length) return;

    if (window.innerWidth < 990) {
      kaartMinHoogte = 0;
      kaarten.forEach(function (k) { k.style.minHeight = ''; });
      return;
    }

    /*
     * Meten kan alleen eerlijk als alles dicht is; staat er een uitklap open
     * (na een ruil bijvoorbeeld), dan houden we de eerder gemeten waarde aan.
     */
    var openPaneel = el.kaarten.querySelector('.gq-pdetail.is-open');
    if (!openPaneel) {
      kaarten.forEach(function (k) { k.style.minHeight = ''; });
      kaartMinHoogte = 0;
      kaarten.forEach(function (k) {
        if (k.offsetHeight > kaartMinHoogte) kaartMinHoogte = k.offsetHeight;
      });
    }
    if (kaartMinHoogte) {
      kaarten.forEach(function (k) { k.style.minHeight = kaartMinHoogte + 'px'; });
    }
  }

  /* Is de reviewwidget van Stamped op deze pagina te verwachten? */
  function stampedAanwezig() {
    return Boolean(window.StampedFn || document.querySelector('script[src*="stamped.io"]'));
  }

  function stampedBadge(geur) {
    if (!geur.id || !stampedAanwezig()) return null;
    var houder = elementje('span', 'gq-pcard-rate gq-pcard-rate--stamped');
    var span = elementje('span', 'stamped-product-reviews-badge stamped-main-badge');
    span.setAttribute('data-id', geur.id);
    span.setAttribute('data-product-title', geur.titel);
    span.setAttribute('data-product-sku', geur.handle);
    houder.appendChild(span);
    return houder;
  }

  /*
   * Stamped vult de badges bij het laden van de pagina, maar onze kaarten
   * bestaan dan nog niet -- en na een ruil komt er een verse kaart bij. Dus na
   * elke keer kaarten tekenen zelf vragen of hij opnieuw wil kijken. Het
   * script kan nog onderweg zijn; een paar keer proberen en dan opgeven.
   */
  function laadStampedBadges(poging) {
    poging = poging || 0;
    if (window.StampedFn && typeof window.StampedFn.loadBadges === 'function') {
      try {
        window.StampedFn.loadBadges();
      } catch (fout) {
        /* De widget mag nooit de uitslag breken. */
      }
      return;
    }
    if (poging < 10 && stampedAanwezig()) {
      window.setTimeout(function () { laadStampedBadges(poging + 1); }, 400);
    }
  }

  function kaartVoor(kandidaat, nummer, procent) {
    var geur = kandidaat.geur;
    var L = T.uitslag;

    var item = document.createElement('li');
    /* results-intro.js zoekt de kaarten hierop; de klassen zet dat script zelf. */
    item.setAttribute('data-anim', 'card');
    var kaart = elementje('article', 'gq-pcard');

    /* --- fotovlak met volgnummer --- */
    var vlak = elementje('div', 'gq-pcard-img');
    vlak.appendChild(elementje('span', 'gq-rank', ('0' + nummer).slice(-2)));

    /*
     * Welke foto op de kaart staat is een instelling. Het losse flesje op
     * transparant staat nog niet bij elke geur; zolang dat zo is leest een
     * gemengde lijst rommelig, dus staat hij standaard op de gewone productfoto.
     */
    var bron = T.kaartFoto === 'flesje' ? geur.flesje || geur.afbeelding : geur.afbeelding || geur.flesje;
    if (bron) {
      var img = document.createElement('img');
      img.src = bron;
      img.alt = '';
      img.loading = 'lazy';
      vlak.appendChild(img);
    }
    kaart.appendChild(vlak);

    /* --- rechterkolom --- */
    var lijf = elementje('div', 'gq-pcard-body');

    var boven = elementje('p', 'gq-pcard-top');
    /*
     * De sterren komen live van Stamped, dezelfde widget als op de
     * productpagina -- de cijfers uit de metafields liepen achter (Red Carpet
     * stond op 9 reviews waar de widget er 21 kent). De widgetcode staat als
     * app-embed op elke pagina; wij zetten alleen het element neer dat hij
     * vult, met exact de attributen die de productpagina ook gebruikt.
     *
     * Geen Stamped (script geblokkeerd, of geen id in de data)? Dan de oude
     * metafield-sterren -- verouderd is beter dan leeg.
     */
    var badge = stampedBadge(geur);
    if (badge) {
      boven.appendChild(badge);
    } else if (geur.rating && geur.ratingAantal) {
      var rate = elementje('span', 'gq-pcard-rate');
      rate.appendChild(elementje('span', 'gq-star', '★'));
      rate.appendChild(
        document.createTextNode(' ' + geur.rating.toFixed(1).replace('.', ',') + ' (' + geur.ratingAantal + ')')
      );
      boven.appendChild(rate);
    }
    lijf.appendChild(boven);

    var titel = elementje('h2', 'gq-pcard-title');
    var link = elementje('a', null, geur.titel);
    /*
     * De doorklik naar de productpagina was het enige pad op deze bladzijde dat
     * nergens werd geteld. Wie hier klikt, leest en dáár koopt, telde niet mee
     * als quiz-aankoop -- terwijl driekwart van dit publiek 45-plus is en die
     * groep juist eerst wil lezen. De sessie gaat mee in de url zodat een
     * bestelling die daar ontstaat alsnog aan deze uitslag hangt.
     */
    link.href = '/products/' + geur.handle +
      '?gq=' + encodeURIComponent(sessieNummer()) + '&gqp=' + nummer;
    link.addEventListener('click', function () {
      meet(NAMEN.doorgeklikt, {
        Positie: Array.prototype.indexOf.call(el.kaarten.children, item) + 1,
        Geur: geur.titel,
        Handle: geur.handle,
        Geruild: !!(historie[nummer - 1] || []).length,
      });
    });
    titel.appendChild(link);
    lijf.appendChild(titel);

    if (geur.kort) lijf.appendChild(elementje('p', 'gq-pcard-why', geur.kort));

    /* Twee stijlpillen, altijd twee; kleur en icoon uit het palet. */
    if ((geur.stijlen || []).length) {
      var rij = elementje('div', 'gq-notes');
      geur.stijlen.forEach(function (stijl) {
        var pil = elementje('span', 'gq-note');
        if (stijl.bg) {
          pil.style.background = stijl.bg;
          pil.style.color = stijl.fg;
        }
        if (stijl.icoon && ICONEN[stijl.icoon]) pil.appendChild(maakSvg(ICONEN[stijl.icoon]));
        pil.appendChild(document.createTextNode(stijl.label));
        rij.appendChild(pil);
      });
      lijf.appendChild(rij);
    }

    /*
     * Is er op deze plek al geruild, dan staat er wat er weg is, met de weg
     * terug. Alleen dan -- op een kaart die nog op zijn oorspronkelijke advies
     * staat is deze regel leeg en kost hij geen hoogte.
     */
    var eerder = historie[nummer - 1] || [];
    if (eerder.length) {
      var ruilRegel = elementje('p', 'gq-c-swap');
      ruilRegel.appendChild(
        elementje('span', null, vul(L.geruildVan, { geur: eerder[eerder.length - 1].geur.titel }))
      );

      var terugKnop = elementje('button', 'gq-c-swapbtn', L.ruilTerug);
      terugKnop.type = 'button';
      /* Niet 'data-gq-terug': dat is de terugknop in de vragen. */
      terugKnop.setAttribute('data-gq-ruil-terug', '');
      terugKnop.setAttribute(
        'aria-label',
        vul(L.ruilTerugAria, { geur: eerder[eerder.length - 1].geur.titel })
      );
      terugKnop.addEventListener('click', function () {
        var plek = Array.prototype.indexOf.call(el.kaarten.children, item);
        var stapel = historie[plek];
        if (!stapel || !stapel.length) return;
        terugKnop.disabled = true;
        vervang(item, stapel.pop(), true);
      });
      ruilRegel.appendChild(terugKnop);
      lijf.appendChild(ruilRegel);
    }

    /*
     * Een leeg vak dat de overgebleven hoogte opeet, zodat de voetregel op
     * desktop onderaan de kaart staat en twee buren hun prijs en knop op
     * dezelfde lijn hebben. Op mobiel is er niets over te verdelen en is hij nul
     * hoog.
     *
     * Een leeg element dus -- en base.css zet `div:empty` op display: none.
     * Vandaar de klasse mét ouder in de css, die weegt zwaarder.
     */
    lijf.appendChild(elementje('div', 'gq-c-rek'));

    /*
     * De losse prijs naast de setprijs. Dat contrast is het argument voor de
     * set en hoort daarom op elke kaart.
     */
    var voet = elementje('div', 'gq-c-foot');
    var prijs = elementje('p', 'gq-c-price', geld(geur.prijs || STUKPRIJS_TERUGVAL));
    prijs.appendChild(
      elementje('small', null, vul(L.inDeSet, { prijs: geld(prijsPerStuk(procent, geur.prijs)) }))
    );
    voet.appendChild(prijs);

    /*
     * De ruilknop staat naast Add en niet erin: gelijke hoogte, maar zonder
     * vulling en zonder tekst. Twee rondgaande pijlen zeggen "haal er een
     * andere bij" zonder ruimte te kosten in een kolom die op een telefoon
     * maar zo'n 200px breed is, en zonder te concurreren met de koopknop.
     */
    var ruilKnop = elementje('button', 'gq-c-btn gq-c-swapicon');
    ruilKnop.type = 'button';
    ruilKnop.setAttribute('data-gq-ruil', '');
    ruilKnop.setAttribute('aria-label', vul(L.ruilenAria, { geur: geur.titel }));
    ruilKnop.setAttribute('title', L.ruilen);
    ruilKnop.appendChild(
      maakSvg(
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
          'stroke-linecap="round" stroke-linejoin="round">' +
          '<path d="M21 12a9 9 0 0 1-9 9 9 9 0 0 1-7.5-4"/><path d="M3 12a9 9 0 0 1 9-9 9 9 0 0 1 7.5 4"/>' +
          '<path d="M19.5 3v4h-4"/><path d="M4.5 21v-4h4"/></svg>'
      )
    );

    if (!erIsNogWat()) {
      ruilKnop.disabled = true;
      ruilKnop.setAttribute('aria-label', L.ruilenOp);
      ruilKnop.setAttribute('title', L.ruilenOp);
    } else {
      ruilKnop.addEventListener('click', function () {
        var kandidaat = volgende();
        /*
         * De reserve kan sinds het tekenen van deze kaart leeggeraakt zijn op
         * een andere kaart. Dan is dit geen fout maar het einde van de lijst.
         */
        if (!kandidaat) {
          ruilKnop.disabled = true;
          ruilKnop.setAttribute('aria-label', L.ruilenOp);
          ruilKnop.setAttribute('title', L.ruilenOp);
          return;
        }
        /* Twee snelle tikken zouden een geur overslaan die niemand zag. */
        ruilKnop.disabled = true;
        vervang(item, kandidaat, false);
      });
    }
    voet.appendChild(ruilKnop);

    var los = elementje('button', 'gq-c-btn', L.losToevoegen);
    los.type = 'button';
    /*
     * Een eigen haak, want .gq-c-btn zit sinds de ruilknop op twee knoppen in
     * dezelfde voetregel. Wie op de klasse selecteert pakt de verkeerde.
     */
    los.setAttribute('data-gq-los', '');
    los.addEventListener('click', function () {
      /*
       * Positie meemeten en niet alleen het parfum. Welke plek mensen los
       * toevoegen is de enige manier om te zien of slot 1 zijn gewicht waard is
       * en of het laatste slot iets doet; zonder dit getal is elke wijziging aan
       * de volgorde een gok.
       */
      meet(NAMEN.losToegevoegd, {
        Positie: Array.prototype.indexOf.call(el.kaarten.children, item) + 1,
        Geur: geur.titel,
        Handle: geur.handle,
        $value: prijsPerStuk(procent, geur.prijs) / 100,
        Geruild: !!(historie[nummer - 1] || []).length,
      });
      voegToe([{ id: Number(geur.variant), quantity: 1 }], los);
    });
    voet.appendChild(los);
    lijf.appendChild(voet);

    kaart.appendChild(lijf);

    /* --- uitklap --- */
    kaart.appendChild(detailVoor(geur));

    var knop = elementje('button', 'gq-pcard-toggle');
    knop.type = 'button';
    knop.setAttribute('aria-label', L.meerOver);
    knop.setAttribute('aria-expanded', 'false');
    knop.appendChild(
      maakSvg(
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
          'stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>'
      )
    );
    knop.addEventListener('click', function () {
      var paneel = kaart.querySelector('.gq-pdetail');
      var open = paneel.classList.toggle('is-open');
      knop.classList.toggle('is-open', open);
      knop.setAttribute('aria-expanded', String(open));
    });
    kaart.appendChild(knop);

    item.appendChild(kaart);
    return item;
  }

  function detailVoor(geur) {
    var L = T.uitslag;

    var buiten = elementje('div', 'gq-pdetail');
    var midden = elementje('div', 'gq-pdetail-w');
    var binnen = elementje('div', 'gq-pdetail-in');

    if (geur.lang) binnen.appendChild(elementje('p', 'gq-pd-scent', geur.lang));

    /* --- de notenpiramide --- */
    var lagen = [
      [T.lagen.top, geur.notenTop],
      [T.lagen.hart, geur.notenHart],
      [T.lagen.basis, geur.notenBasis],
    ].filter(function (paar) {
      return paar[1] && paar[1].length;
    });

    if (lagen.length) {
      var noten = document.createElement('div');
      noten.appendChild(elementje('p', 'gq-pd-h', L.kopNoten));
      lagen.forEach(function (paar) {
        var rij = elementje('div', 'gq-pyr-row');
        rij.appendChild(elementje('span', 'gq-pyr-lbl', paar[0]));
        rij.appendChild(elementje('span', 'gq-pyr-val', paar[1].map(nootLabel).join(', ')));
        noten.appendChild(rij);
      });
      binnen.appendChild(noten);
    }

    /* --- intensiteit: vijf staafjes plus tekst --- */
    var niveau = config.intensiteit[geur.sillage];
    if (niveau) {
      var blok = document.createElement('div');
      blok.appendChild(elementje('p', 'gq-pd-h', L.kopIntensiteit));

      var wrap = elementje('div', 'gq-vol-wrap');
      var balken = elementje('span', 'gq-vol');
      [7, 10, 13, 16, 19].forEach(function (hoogte, i) {
        var staaf = document.createElement('span');
        staaf.style.height = hoogte + 'px';
        if (i < niveau.n) staaf.className = 'is-on';
        balken.appendChild(staaf);
      });
      wrap.appendChild(balken);

      var tekst = elementje('span', 'gq-vol-txt');
      tekst.appendChild(elementje('strong', null, niveau.label));
      /* De houdbaarheid hoort hier, per geur. Ontbreekt hij, dan valt hij weg. */
      tekst.appendChild(
        elementje('em', null, niveau.tekst + (geur.longevity ? ', ' + geur.longevity : ''))
      );
      wrap.appendChild(tekst);

      blok.appendChild(wrap);
      binnen.appendChild(blok);
    }

    /* --- past bij: alles tonen, wat niet past gedimd --- */
    var past = document.createElement('div');
    past.appendChild(elementje('p', 'gq-pd-h', L.kopPastBij));
    /*
     * Gender verhuisde van de bovenregel van de kaart hierheen, op verzoek: op
     * de kaart stond hij naast de reviews te dringen, hier staat hij tussen de
     * andere past-bij-rijen. En hier heet het Women/Men/Unisex, niet
     * Feminine/Masculine -- dat zijn de vraagteksten, dit zijn de winkelwoorden.
     */
    var genderLabels = {
      Vrouwelijk: L.labelWomen,
      Mannelijk: L.labelMen,
      Neutraal: L.labelUnisex,
    };
    past.appendChild(
      fitRij(L.labelGender, [L.labelWomen, L.labelMen, L.labelUnisex], [genderLabels[geur.gender]])
    );
    past.appendChild(fitRij(L.labelSeizoen, config.past_bij.seizoenen, geur.seizoenen || []));
    past.appendChild(fitRij(L.labelMoment, config.past_bij.momenten, geur.momenten || []));
    binnen.appendChild(past);

    midden.appendChild(binnen);
    buiten.appendChild(midden);
    return buiten;
  }

  function fitRij(label, alle, actief) {
    var rij = elementje('div', 'gq-pyr-row');
    rij.appendChild(elementje('span', 'gq-pyr-lbl', label));

    var chips = elementje('span', 'gq-pyr-chips');
    alle.forEach(function (naam) {
      var aan = actief.indexOf(naam) > -1;
      chips.appendChild(elementje('span', 'gq-fit-chip' + (aan ? '' : ' is-dim'), naam));
    });

    rij.appendChild(chips);
    return rij;
  }

  /* ------------------------------------------------------------- de set-band */

  /*
   * Het nieuwe setblok vullen met wat de set écht kost.
   *
   * De teksten staan als instelling in de sectie, maar de bedragen niet: levert
   * de quiz een keer vijf geuren in plaats van zes, dan geldt een andere staffel
   * en zou een vaste prijs iets anders beloven dan de kassa rekent. De vorm van
   * de zin blijft van de winkelier, alleen de getallen komen hiervandaan.
   */
  function tekenSetblok(set) {
    if (!el.setblok) return;

    var sectie = el.setblok;
    if (!set.length) {
      sectie.hidden = true;
      return;
    }
    sectie.hidden = false;

    var L = T.uitslag;
    var procent = procentVoor(set.length);
    var vol = set.reduce(function (som, k) { return som + k.geur.prijs; }, 0);
    var nu = set.reduce(function (som, k) { return som + prijsPerStuk(procent, k.geur.prijs); }, 0);

    if (el.setblokPrijs) el.setblokPrijs.textContent = geld(nu);

    /*
     * Zonder korting is er niets om door te strepen. Leeghalen en niet
     * verbergen: de balk rekent met wat er staat, en een verborgen element dat
     * later terugkomt laat de regel verspringen.
     */
    if (el.setblokVan) el.setblokVan.textContent = procent > 0 ? geld(vol) : '';
    if (el.setblokKorting) el.setblokKorting.textContent = procent > 0 ? '\u2212' + procent + '%' : '';

    if (el.setblokBesparing) {
      el.setblokBesparing.textContent = vul(L.setblokBesparing, {
        aantal: set.length,
        bespaart: geld(vol - nu),
        perstuk: geld(Math.round(nu / set.length)),
      });
    }
  }

  function tekenSet(set) {
    tekenSetblok(set);

    if (!el.set) return;

    if (!set.length) {
      el.set.hidden = true;
      if (el.sticky) el.sticky.hidden = true;
      return;
    }

    var L = T.uitslag;
    var procent = procentVoor(set.length);
    var vol = set.reduce(function (som, k) { return som + k.geur.prijs; }, 0);
    var nu = set.reduce(function (som, k) { return som + prijsPerStuk(procent, k.geur.prijs); }, 0);

    el.setKop.textContent = vul(L.setKop, { aantal: set.length });

    leeg(el.setPrijs);
    el.setPrijs.setAttribute('translate', 'no');
    el.setPrijs.classList.add('wg-notranslate');
    el.setPrijs.appendChild(elementje('span', 'gq-p-now', geld(nu)));
    if (procent > 0) {
      el.setPrijs.appendChild(elementje('span', 'gq-p-was', geld(vol)));
      el.setPrijs.appendChild(elementje('span', 'gq-p-off', '−' + procent + '%'));
    }

    el.setBesparing.textContent = vul(L.besparing, {
      aantal: set.length,
      bespaart: geld(vol - nu),
      perstuk: geld(Math.round(nu / set.length)),
    });

    el.setKnop.textContent = L.setKnop;
    el.setKnop.disabled = false;
    el.set.hidden = false;

    if (el.sticky) {
      el.stickyKop.textContent = vul(L.stickyKop, { aantal: set.length });
      el.stickyPrijs.textContent =
        geld(nu) + ' · ' + geld(vol) + (procent ? ' · −' + procent + '%' : '');
      el.stickyKnop.textContent = L.stickyKnop;
      el.sticky.hidden = false;
      volgSticky();
    }
  }

  /*
   * De balk verschijnt zodra de kaarten in beeld komen en verdwijnt zodra de
   * donkere band er is -- die heeft dezelfde knop, en twee keer dezelfde actie
   * naast elkaar is er één te veel.
   */
  /*
   * De twee kijkers staan buiten de functie omdat tekenSet() nu vaker dan één
   * keer draait -- elke ruil tekent de prijsband opnieuw. Zonder opruimen
   * stapelen ze zich op en blijft elke oude kijker de balk aansturen.
   */
  var kijkers = [];

  function volgSticky() {
    if (!window.IntersectionObserver || !el.sticky || !el.kaarten || !el.set) return;

    kijkers.forEach(function (k) { k.disconnect(); });
    kijkers = [];

    var kaartenGezien = false;
    var bandGezien = false;

    function bijwerken() {
      el.sticky.classList.toggle('is-op', kaartenGezien && !bandGezien);
    }

    var opKaarten = new window.IntersectionObserver(function (regels) {
      regels.forEach(function (r) {
        kaartenGezien = r.isIntersecting || r.boundingClientRect.top < 0;
      });
      bijwerken();
    });
    opKaarten.observe(el.kaarten);

    var opBand = new window.IntersectionObserver(function (regels) {
      regels.forEach(function (r) {
        bandGezien = r.isIntersecting;
      });
      bijwerken();
    });
    opBand.observe(el.set);

    kijkers = [opKaarten, opBand];
  }

  /* ------------------------------------------------------------- toevoegen -- */

  /*
   * De mandjesteller in de kop staat stil tijdens de quiz (zie de klasse
   * gq-mandje-stil in layout/theme.liquid). Zodra er echt iets is toegevoegd
   * mag hij er zijn -- dan is er ook iets om te tellen.
   *
   * Het onthouden gebeurt in sessionStorage, want de klasse komt bij elke
   * paginaweergave terug uit Liquid. Zonder dat zou de teller na een verversing
   * of na terugkomen op de uitslag weer verdwijnen terwijl er wel spullen in
   * het mandje liggen.
   */
  var MANDJE_VRIJ = 'sentir:geurquiz:mandje';
  var huidigScherm = 'intro';

  function mandjeIsVrijgegeven() {
    try {
      return !!window.sessionStorage.getItem(MANDJE_VRIJ);
    } catch (fout) {
      return false;
    }
  }

  /*
   * De badge volgt het SCHERM, niet alleen de sessie. Eerst was één toevoeging
   * genoeg om hem voor de rest van de sessie te tonen -- maar wie daarna de
   * quiz opnieuw deed, zat weer met een teller boven de vragen. Nu: stil op de
   * intro en de vragen, altijd; op de uitslag zichtbaar zodra er in deze sessie
   * echt iets vanaf de uitslag is toegevoegd.
   */
  function werkBadgeBij(scherm) {
    if (scherm) huidigScherm = scherm;
    var vrij = huidigScherm === 'uitslag' && mandjeIsVrijgegeven();
    document.documentElement.classList.toggle('gq-mandje-vrij', vrij);
    document.documentElement.classList.toggle('gq-mandje-stil', !vrij);
  }

  function geefMandjeVrij() {
    try {
      window.sessionStorage.setItem(MANDJE_VRIJ, '1');
    } catch (fout) {
      /* Privémodus; dan geldt het alleen voor dit scherm. */
    }
    werkBadgeBij();
  }

  /*
   * Meteen bij het laden, vóór het eerste toon(): de klasse is ook de terugval
   * voor browsers zonder :has(), waar de teller anders even opflitst.
   */
  werkBadgeBij('intro');

  /*
   * Zichtbare bevestiging op de knop zelf: even groen met een vinkje en "In your
   * cart", daarna weer de gewone tekst. De statusregel (.gq-status) hoorde bij het
   * oude donkere setblok -- witte tekst die op de lichte uitslag onzichtbaar werd --
   * en is nu alleen nog voor schermlezers.
   */
  function bevestigOpKnop(knop) {
    if (!knop) return;
    if (!knop.dataset.gqLabel) knop.dataset.gqLabel = knop.innerHTML;
    window.clearTimeout(knop._gqTerug);
    var tekst = String(T.uitslag.toegevoegd || '').replace(/\.\s*$/, '');
    knop.innerHTML =
      '<svg class="gq-btn-vink" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
      '<path d="M3.5 8.4l2.9 2.9 6.1-6.6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    knop.appendChild(document.createTextNode(tekst));
    knop.classList.add('is-toegevoegd');
    knop._gqTerug = window.setTimeout(function () {
      knop.innerHTML = knop.dataset.gqLabel;
      delete knop.dataset.gqLabel;
      knop.classList.remove('is-toegevoegd');
    }, 2600);
  }

  function voegToe(items, knop) {
    if (!items.length) return;

    if (knop) knop.disabled = true;
    melden('');

    function misgegaan() {
      if (knop) knop.disabled = false;
      melden(T.uitslag.mislukt);
      try {
        if (knop) knop.focus();
      } catch (fout) {
        /* niets */
      }
    }

    /*
     * De sessiekenmerken gaan pas ná het toevoegen naar het mandje. Toen ze
     * ervóór vertrokken, gingen update.js en add.js in dezelfde tick de deur
     * uit; bij een bezoeker zonder mandje maakt elk verzoek dan zijn éigen
     * mandje aan, en wint de traagste response de cookie -- add.js. De klant
     * rekende af met de geuren maar zonder _geurquiz_sessie, en geen enkele
     * bestelling was nog aan de quiz te koppelen.
     */
    if (window.SentirCart && typeof window.SentirCart.add === 'function') {
      window.SentirCart.add({ items: items }, { trigger: knop })
        .then(function () {
          merkMandje();
          melden(T.uitslag.toegevoegd);
          bevestigOpKnop(knop);
          geefMandjeVrij();
          if (knop) knop.disabled = false;
        })
        .catch(misgegaan);
      return;
    }

    window
      .fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
      .then(function (res) {
        if (!res.ok) throw new Error('status ' + res.status);
        geefMandjeVrij();
        /* Eerst laten landen: de navigatie hierna breekt elke lopende fetch af. */
        return merkMandje();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(misgegaan);
  }

  function alleZes(knop) {
    if (!getoond.length) return;

    /*
     * Het bedrag NA de staffelkorting. Stond hier de som van de losse prijzen,
     * dan meldt de quiz 89,70 waar de kassa 53,82 rekent -- 67% te hoog, en
     * daarmee onvergelijkbaar met elk ander omzetcijfer in Klaviyo.
     */
    var procent = procentVoor(getoond.length);
    var bedrag = getoond.reduce(function (som, k) {
      return som + prijsPerStuk(procent, k.geur.prijs);
    }, 0);
    var vol = getoond.reduce(function (som, k) { return som + k.geur.prijs; }, 0);

    meet(NAMEN.toegevoegd, {
      Aantal: getoond.length,
      $value: bedrag / 100,
      Vol_bedrag: vol / 100,
      Korting: procent,
      /* Zodat achteraf te zien is of ruilen tot meer of minder mandjes leidt. */
      Geruild: geruild,
      Geuren: getoond.map(function (k) { return k.geur.titel; }),
    });

    voegToe(
      getoond.map(function (k) {
        return { id: Number(k.geur.variant), quantity: 1 };
      }),
      knop
    );
  }

  function melden(tekst) {
    if (el.status) el.status.textContent = tekst;
  }

  function merkMandje() {
    if (!window.fetch) return null;

    return window
      .fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: {
            _geurquiz_sessie: sessieNummer(),
            _geurquiz_code: naarCode(antwoorden),
            /*
             * De code bevat de antwoorden, en daaruit volgt de oorspronkelijke
             * aanbeveling. Heeft de klant geruild, dan klopt die niet meer met
             * wat er op zijn scherm stond -- vandaar ook de geuren zelf.
             */
            _geurquiz_set: getoond
              .map(function (k) { return k.geur.handle; })
              .join(','),
          },
        }),
      })
      .catch(function () {
        /* niets */
      });
  }

  /* --------------------------------------------------------------- proeven -- */

  /*
   * Het proevenraamwerk. De bron is het shop-metafield sentir.proeven, dat het
   * dashboard beheert en dat de sectie in de teksten-JSON meegeeft; is er geen
   * metafield, dan staat alles uit en is dit exact de quiz zonder proeven.
   *
   * Drie soorten bijsturing, alle drie zonder themapush aan of uit te zetten:
   *  - model:      vaste bijsturing voor iedereen (bv. de conversiebonus);
   *  - verkenning: de wildcard op plek zes, met een kans en een kopgroepgrens;
   *  - proeven:    A/B-varianten met elk een eigen bijsturing. Eén tegelijk
   *                actief -- met dit bezoekersvolume is meer tegelijk toch
   *                niet uit elkaar te rekenen.
   *
   * De toewijzing hangt aan het sessienummer: deterministisch, dus stabiel
   * binnen de sessie, en uniform verdeeld over bezoekers. Elke meting draagt
   * de proefnaam en de variant mee, zodat de trechter per arm te leggen is.
   */

  var PROEVEN = T.proeven && typeof T.proeven === 'object' ? T.proeven : null;
  var proefNaam = null;
  var proefVariant = null;
  var verkendHandle = null;

  function hutsel(tekst) {
    var h = 1779033703 ^ tekst.length;
    for (var i = 0; i < tekst.length; i += 1) {
      h = Math.imul(h ^ tekst.charCodeAt(i), 3432918353);
      h = (h << 13) | (h >>> 19);
    }
    h = Math.imul(h ^ (h >>> 16), 2246822507);
    h = Math.imul(h ^ (h >>> 13), 3266489909);
    return (h ^ (h >>> 16)) >>> 0;
  }

  /*
   * Alleen deze paden mag een proef of het dashboard overschrijven. Bewust een
   * witte lijst en geen vrije merge: het metafield is bereikbaar vanuit de
   * admin, en een tikfout daar mag hooguit een bonus verschuiven -- nooit de
   * drempels of vragenlijst slopen waar de toetsen op staan.
   */
  /*
   * Alleen eindige getallen komen een kaart in, en de prototype-sleutels
   * nooit. Een string "7,9" waar 7.9 bedoeld was zou anders als NaN de hele
   * ranglijstsortering verlammen -- NaN vergelijkt als "gelijk" en de geur
   * blijft dan match-onafhankelijk op zijn collectieplek staan.
   */
  function schoneKaart(bron) {
    var uit = {};
    Object.keys(bron).forEach(function (k) {
      if (k === '__proto__' || k === 'constructor' || k === 'prototype') return;
      var v = bron[k];
      if (typeof v === 'number' && isFinite(v)) uit[k] = v;
    });
    return uit;
  }

  function pasPatchToe(patch) {
    if (!patch || typeof patch !== 'object' || !config) return;

    if (patch.gedrag && typeof patch.gedrag === 'object') {
      config.gedrag = config.gedrag || {};
      ['weging', 'midden'].forEach(function (k) {
        if (typeof patch.gedrag[k] === 'number' && isFinite(patch.gedrag[k])) {
          config.gedrag[k] = patch.gedrag[k];
        }
      });
      if (patch.gedrag.cart_dit && typeof patch.gedrag.cart_dit === 'object') {
        config.gedrag.cart_dit = schoneKaart(patch.gedrag.cart_dit);
      }
    }

    if (patch.straffen && typeof patch.straffen === 'object') {
      if (patch.straffen.rem_per_geur && typeof patch.straffen.rem_per_geur === 'object') {
        config.straffen.rem_per_geur = schoneKaart(patch.straffen.rem_per_geur);
      }
      ['populariteit', 'familie_herhaling'].forEach(function (k) {
        if (typeof patch.straffen[k] === 'number' && isFinite(patch.straffen[k])) {
          config.straffen[k] = patch.straffen[k];
        }
      });
    }
  }

  var proefPatch = null;

  /*
   * De toewijzing staat los van de config: wie op Start klikt terwijl de
   * config nog onderweg is, hoort zijn gestart-meting al mét stempel te
   * sturen -- de database bewaart per (soort, sessie) de eerste rij, en een
   * ongestempelde start is daarna niet meer te repareren. Vandaar: kiezen
   * gebeurt meteen bij het laden, de config-patch pas als die er is.
   */
  function kiesProef() {
    if (!PROEVEN) return;

    var lijst = Array.isArray(PROEVEN.proeven) ? PROEVEN.proeven : [];
    var actief = null;
    for (var i = 0; i < lijst.length; i += 1) {
      if (lijst[i] && lijst[i].actief && lijst[i].naam && lijst[i].varianten) {
        actief = lijst[i];
        break;
      }
    }
    if (!actief) return;

    /*
     * De varianten op alfabet, en de verdeling hoort daarbij aan te sluiten:
     * verdeling [50, 50] bij varianten a en b betekent 50% a. Zonder
     * verdeling krijgt elke variant een gelijk deel.
     */
    var namen = Object.keys(actief.varianten).sort();
    if (namen.length < 2) return;

    var worp = hutsel(sessieNummer() + '|' + actief.naam) % 100;
    var verdeling = Array.isArray(actief.verdeling) ? actief.verdeling : [];
    var grens = 0;
    var gekozen = namen[namen.length - 1];
    for (var j = 0; j < namen.length; j += 1) {
      grens += verdeling[j] !== undefined ? verdeling[j] : Math.floor(100 / namen.length);
      if (worp < grens) {
        gekozen = namen[j];
        break;
      }
    }

    /* Dezelfde grenzen als de relay hanteert; wat langer is, wordt daar toch
     * afgekapt en dan matchen de armen niet meer. */
    proefNaam = String(actief.naam).slice(0, 40);
    proefVariant = String(gekozen).slice(0, 20);
    proefPatch = actief.varianten[gekozen];
  }

  kiesProef();

  /* In de bootketen, zodra de config er is: de bijsturing zelf. */
  function pasProevenToe() {
    if (!config) return;
    if (PROEVEN) pasPatchToe(PROEVEN.model);
    if (proefPatch) pasPatchToe(proefPatch);
  }

  /* Wat adviseer() aan verkenning meekrijgt; null zolang die uit staat. */
  function verkenningInstel() {
    var v = PROEVEN && PROEVEN.verkenning;
    if (!v || !v.actief) return null;

    var kans = Number(v.kans);
    if (!(kans > 0)) return null;
    /*
     * Harde klem op 50%: wie in het metafield 15 typt waar 0,15 bedoeld was,
     * zet anders met één tikfout de hele winkel op wildcard.
     */
    if (kans > 0.5) kans = 0.5;

    var boven = Number(v.boven_top);
    return {
      actief: true,
      kans: kans,
      /* 0 is geldig ("geen beschermde kopgroep"); alleen onzin wordt 20. */
      boven_top: boven >= 0 ? boven : 20,
      zaad: sessieNummer(),
    };
  }

  /* Het stempel dat elke eigen meting meekrijgt; null zolang er niets loopt. */
  function proefStempel() {
    var verkenningAan = Boolean(verkenningInstel());
    if (!proefNaam && !verkendHandle && !verkenningAan) return null;
    var s = {};
    if (proefNaam) {
      s.p = proefNaam;
      s.v = proefVariant;
    }
    if (verkendHandle) s.w = verkendHandle;
    /*
     * Of de verkenning aanstond. Zonder deze vlag is er geen zuivere
     * referentiegroep: "geen wildcard" zou dan ook alle sessies van vóór de
     * verkenning omvatten, en die vergelijking zegt niets.
     */
    if (verkenningAan) s.e = 1;
    return s;
  }

  /* ---------------------------------------------------------------- meten -- */

  /*
   * Vier gebeurtenissen per sessie, niet meer:
   *
   *   gestart     -- iemand klikt op de startknop
   *   afgehaakt   -- hij verlaat de pagina zonder de uitslag te halen
   *   voltooid    -- de uitslag staat er, met alle antwoorden erin
   *   toegevoegd  -- de zes gaan in het mandje, met het bedrag
   *
   * Bewust niet één gebeurtenis per vraag. Dat zou zeven keer zoveel verkeer
   * geven voor precies dezelfde uitkomst: waar mensen afhaken staat in
   * "afgehaakt" als het nummer van de laatste vraag die ze zagen, en welke
   * antwoorden gegeven worden staat in "voltooid".
   *
   * Het sessienummer loopt door alle vier. Daarmee is een bezoeker te volgen van
   * start tot mandje zonder dat we weten wie hij is.
   */
  /*
   * De namen van de gebeurtenissen. Uit de instellingen, want ze verschijnen
   * als metric in Klaviyo en daar bouw je rapporten en flows op -- hernoemen
   * betekent dat de historie eronder blijft liggen. Dus: één keer goed kiezen.
   */
  var NAMEN = T.meten || {};

  var sessie = null;
  var gemeld = {};

  /*
   * Het nummer overleeft een herlaadbeurt binnen dezelfde tab, net als de
   * antwoorden. Dat is er sinds de proeven bijgekomen: de variant en de
   * wildcard hangen aan dit nummer, en een herlaadbeurt op de uitslagpagina
   * mag niet stilletjes een andere set of een andere proefarm opleveren.
   * Dubbele startmetingen na hervatten vallen er ook mee weg: zelfde nummer,
   * en de database telt per (soort, sessie) maar één keer.
   */
  function sessieNummer() {
    if (sessie) return sessie;
    try {
      sessie = window.sessionStorage.getItem(BEWAAR + ':sessie') || null;
    } catch (fout) {
      /* Privémodus; dan leeft het nummer alleen in dit scherm. */
    }
    if (sessie) return sessie;
    sessie =
      Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    try {
      window.sessionStorage.setItem(BEWAAR + ':sessie', sessie);
    } catch (fout) {
      /* niets */
    }
    return sessie;
  }

  /*
   * De webview van een app herkennen. Facebook zet FBAN of FBAV in de
   * user-agent, Instagram zet er Instagram in. Meer dan dat valt er niet
   * betrouwbaar uit te halen, en meer is ook niet nodig: de vraag is alleen of
   * iemand in een app zit of in een echte browser.
   */
  function omgeving() {
    var ua = String(window.navigator.userAgent || '');
    if (/FBAN|FBAV|FB_IAB/.test(ua)) return 'facebook-app';
    if (/Instagram/.test(ua)) return 'instagram-app';
    if (/\bLine\/|Snapchat|TikTok|Pinterest/.test(ua)) return 'andere-app';
    return 'browser';
  }

  /*
   * Het eigen ontvangstpunt, afgeleid van het aanmeldadres: zelfde Worker,
   * ander pad. Klaviyo bewaart namelijk niets van bezoekers die het niet kent
   * (bewezen met een live proef): hun events blijven in de browser hangen en
   * verlopen daar. Dit adres bewaart ze wél -- zonder persoonsgegevens, alleen
   * het sessienummer en de antwoorden.
   */
  var MEET_ADRES = (function () {
    var basis = String(T.aanmeldAdres || '');
    if (!basis) return null;
    var adres = basis.replace(/\/aanmelden\/?(\?.*)?$/, '/meet');
    return adres !== basis && /^https?:/.test(adres) ? adres : null;
  })();

  function soortVan(naam) {
    if (!naam) return null;
    if (naam === NAMEN.gestart) return 'gestart';
    if (naam === NAMEN.afgehaakt) return 'afgehaakt';
    if (naam === NAMEN.voltooid) return 'voltooid';
    if (naam === NAMEN.toegevoegd) return 'toegevoegd';
    return null;
  }

  /*
   * sendBeacon en niet fetch, waar het kan: het afhaak-event vertrekt op het
   * moment dat de bezoeker de pagina verlaat, en dat is precies waar fetch
   * sneuvelt en een beacon nog aankomt. text/plain houdt het een simple
   * request zonder preflight.
   */
  function meldEigenMeting(naam, lading) {
    try {
      var soort = soortVan(naam);
      if (!soort || !MEET_ADRES) return;

      var pak = {
        soort: soort,
        sessie: lading.Sessie,
        apparaat: lading.Apparaat,
        omgeving: lading.Omgeving,
      };
      if (soort === 'afgehaakt') pak.laatste_vraag = lading.Laatste_vraag;
      if (soort === 'toegevoegd') {
        pak.waarde = lading.$value;
        pak.code = naarCode(antwoorden);
        /*
         * Wélke geuren er in het mandje gingen. Tot nu toe was per geur alleen
         * te zien of hij werd aangeraden en of hij werd besteld; dit vult het
         * gat ertussen, en het is de teller waar de verkenning op drijft.
         */
        pak.mand = getoond.map(function (k) {
          return k.geur.titel;
        });
      }

      var stempel = proefStempel();
      if (stempel && stempel.w && soort === 'toegevoegd') {
        /*
         * Weggeruild vóór het toevoegen? Dan is dit mandje geen verdienste
         * van de wildcard en telt het niet als verkenningssucces -- anders
         * meet de wildcard-tabel de kwaliteit van de gewone set.
         */
        var wildcardNogInSet = getoond.some(function (k) {
          return k.geur.handle === stempel.w;
        });
        if (!wildcardNogInSet) delete stempel.w;
      }
      if (stempel) pak.proef = stempel;
      if (soort === 'voltooid') {
        pak.code = lading.Quiz_code;
        pak.topmatch = lading.Topmatch;
        pak.aanbevolen = lading.Aanbevolen;
        pak.antwoorden = {
          richting: lading.Richting,
          families: lading.Geurfamilies_lijst,
          noten: lading.Noten_lijst,
          dealbreakers: lading.Dealbreakers_lijst,
          aanwezigheid: lading.Aanwezigheid,
          moment: lading.Moment,
          warmOfFris: lading.Warm_of_fris,
          karakter: lading.Karakter,
        };
      }

      var tekst = JSON.stringify(pak);
      if (window.navigator && navigator.sendBeacon) {
        navigator.sendBeacon(MEET_ADRES, new Blob([tekst], { type: 'text/plain' }));
      } else if (window.fetch) {
        window.fetch(MEET_ADRES, {
          method: 'POST',
          body: tekst,
          keepalive: true,
          headers: { 'Content-Type': 'text/plain' },
        });
      }
    } catch (fout) {
      /* Meten mag nooit de quiz breken. */
    }
  }

  function meet(naam, extra) {
    var lading = Object.assign(
      {
        Sessie: sessieNummer(),
        Quiz: 'geurquiz',
        Apparaat: window.innerWidth < 750 ? 'mobiel' : 'desktop',
        /*
         * Twee op de drie bezoekers komt binnen via de app van Facebook of
         * Instagram, en die groep legt 33 tot 46% minder in het mandje dan
         * dezelfde leeftijd in een gewone browser. Zonder dit veld ziet een
         * verschuiving in de verkeersmix eruit als een betere of slechtere
         * quiz, en stuur je op de verkeerde knop.
         */
        Omgeving: omgeving(),
      },
      extra || {}
    );

    /* Loopt er een proef of een verkenning, dan draagt élke meting dat mee --
     * anders is er achteraf geen trechter per arm te leggen. */
    if (proefNaam) {
      lading.Proef = proefNaam;
      lading.Variant = proefVariant;
    }
    if (verkendHandle) lading.Verkend = verkendHandle;

    /* Eerst de eigen meting: die werkt ook als Klaviyo er niet is of de
     * bezoeker daar onbekend is. */
    meldEigenMeting(naam, lading);

    try {
      if (window.klaviyo && typeof window.klaviyo.track === 'function') {
        window.klaviyo.track(naam, lading);
      } else if (window._learnq) {
        window._learnq.push(['track', naam, lading]);
      }
    } catch (fout) {
      /* Meten mag nooit de quiz breken. */
    }
  }

  /* Eén keer per sessie, ook als de bezoeker heen en weer navigeert. */
  function meetEens(naam, extra) {
    if (gemeld[naam]) return;
    gemeld[naam] = true;
    meet(naam, extra);
  }

  /*
   * Afhaken meten bij het wegklikken. visibilitychange en niet beforeunload:
   * op een telefoon vuurt beforeunload vaak niet als je de app wegveegt of naar
   * een ander tabblad gaat, en dat is nu net waar het meeste verkeer vandaan
   * komt.
   */
  function meldAfhaken() {
    if (!gemeld[NAMEN.gestart] || gemeld[NAMEN.voltooid]) return;

    meetEens(NAMEN.afgehaakt, {
      Laatste_vraag: stap + 1,
      Laatste_vraag_sleutel: (VRAGEN[stap] || {}).sleutel || '',
      Vragen_beantwoord: Object.keys(antwoorden).length,
    });
  }

  /*
   * Twee haken, want geen van beide vuurt overal. visibilitychange mist het
   * moment dat iemand de tab echt sluit; pagehide mist het wegvegen van de app
   * op iOS. meetEens zorgt dat het er hoe dan ook maar één keer uit gaat.
   */
  var hoogteTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(hoogteTimer);
    hoogteTimer = setTimeout(gelijkeKaarthoogtes, 200);
  }, { passive: true });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') meldAfhaken();
  });
  window.addEventListener('pagehide', meldAfhaken);

  /* ------------------------------------------------------------------ Klaviyo */

  /*
   * Eén gebeurtenis met de volledige uitslag erin. Dat levert tegelijk de
   * analyse en de personalisatie: de zes aanbevelingen in een opvolgmail zetten
   * is dan een kwestie van het veld uitlezen.
   */
  /* De laatste uitslag als profielgegevens: gaat opnieuw mee als iemand zich via het Klaviyo-formulier aanmeldt. */
  var laatsteUitslag = null;

  function naarKlaviyo(set, echt) {
    var api = window.klaviyo || window._learnq;
    if (!api) return;

    try {
      var lading = {
        Richting: labelVan('v1', antwoorden.v1),
        /*
         * Zowel de opsomming als de losse waarden. Alleen een komma-tekst
         * bewaren betekent één hokje per COMBINATIE -- "Floral, Woody" is dan
         * iets anders dan "Woody, Floral" -- en dan valt er niet per antwoord
         * te tellen. De lijst maakt dat wel mogelijk, de tekst leest prettiger
         * in een profiel.
         */
        Geurfamilies: (antwoorden.v2 || []).map(familieLabel).join(', '),
        Geurfamilies_lijst: (antwoorden.v2 || []).map(familieLabel),
        Geurfamilies_aantal: (antwoorden.v2 || []).length,
        Noten: (antwoorden.v3 || []).map(nootLabel).join(', '),
        Noten_lijst: (antwoorden.v3 || []).map(nootLabel),
        Noten_aantal: (antwoorden.v3 || []).length,
        Dealbreakers: (antwoorden.v4 || []).join(', ') || 'geen',
        Dealbreakers_lijst: antwoorden.v4 || [],
        Dealbreakers_aantal: (antwoorden.v4 || []).length,
        Aanwezigheid: antwoorden.v5,
        Moment: antwoorden.v6,
        Warm_of_fris: antwoorden.v7,
        /*
         * v8 ontbrak hier eerst. De vraag stuurde de uitslag wel (twaalf
         * punten) maar was in geen enkele sessie terug te zien -- precies het
         * antwoord dat een set vol eigenzinnige geuren verklaart.
         */
        Karakter: antwoorden.v8 || '',
        Aanbevolen: set.map(function (k) {
          return k.geur.titel;
        }),
        Topmatch: set.length ? set[0].geur.titel : '',
        Aantal_getoond: set.length,
        Quiz_code: naarCode(antwoorden),
        Quiz_voltooid: new Date().toISOString().slice(0, 10),
      };
      laatsteUitslag = lading;

      /*
       * De uitslag gaat twee kanten op: als eigenschappen naar het profiel
       * (daar segmenteer je op) en als gebeurtenis met het sessienummer (daar
       * meet je de trechter mee). Dezelfde gegevens, een ander doel.
       */
      if (echt) {
        /*
         * Of er voor deze sessie al een afhaakmelding uit is. Twee op de drie
         * bezoekers zit in een app-webview, en wie daar even wegschakelt en
         * terugkomt om af te maken levert nu Gestart + Afgehaakt + Voltooid.
         * Zonder dit veld tel je die persoon als afhaker én als voltooier, en
         * is het afhaakcijfer per vraag onbruikbaar. Nu is hij eruit te filteren.
         */
        meetEens(NAMEN.voltooid, Object.assign({
          Aantal_vragen: VRAGEN.length,
          Eerder_afgehaakt: !!gemeld[NAMEN.afgehaakt],
        }, lading));
      }

      /*
       * Alleen identify hier. De gebeurtenis gaat via meetEens hierboven, met
       * het sessienummer erbij -- stond hij ook hier, dan telde elke voltooiing
       * dubbel en klopte de trechter niet meer.
       */
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify(lading);
      } else if (window._learnq) {
        window._learnq.push(['identify', lading]);
      }
    } catch (fout) {
      console.warn('Geurquiz: melden aan Klaviyo lukte niet.', fout);
    }
  }

  /*
   * Het voorproefje op het introscherm: drie verkleinde kaarten uit de
   * collectie, met twee stijlpillen elk. Die twee pillen zijn geen detail --
   * de echte uitslag toont er ook altijd twee, en één zou hier een belofte
   * doen die daar niet uitkomt.
   */
  function tekenVoorproefje() {
    if (!el.prev || !index) return;

    var kandidaten = index.geuren
      .filter(function (g) {
        var heeftFoto = T.kaartFoto === 'flesje' ? g.flesje : g.afbeelding || g.flesje;
        return heeftFoto && (g.stijlen || []).length >= 2;
      })
      .slice(0, 3);

    if (kandidaten.length < 3) return;

    var procent = procentVoor(config.drempels.set_grootte);
    leeg(el.prevKaarten);

    kandidaten.forEach(function (geur, i) {
      var kaart = document.createElement('div');
      kaart.className = 'gq-mini';

      var vlak = document.createElement('div');
      vlak.className = 'gq-mimg';
      var rank = document.createElement('span');
      rank.className = 'gq-mrank';
      rank.textContent = '0' + (i + 1);
      vlak.appendChild(rank);
      var img = document.createElement('img');
      img.src = T.kaartFoto === 'flesje' ? geur.flesje : geur.afbeelding || geur.flesje;
      img.alt = '';
      img.loading = 'lazy';
      vlak.appendChild(img);
      kaart.appendChild(vlak);

      var lijf = document.createElement('div');
      lijf.className = 'gq-mbody';
      var naam = document.createElement('b');
      naam.textContent = geur.titel;
      lijf.appendChild(naam);

      var pillen = document.createElement('div');
      pillen.className = 'gq-mps';
      geur.stijlen.slice(0, 2).forEach(function (stijl) {
        var pil = document.createElement('span');
        pil.className = 'gq-mp';
        pil.textContent = stijl.label;
        if (stijl.bg) {
          pil.style.background = stijl.bg;
          pil.style.color = stijl.fg;
        }
        pillen.appendChild(pil);
      });
      lijf.appendChild(pillen);

      var prijs = document.createElement('em');
      prijs.textContent = vul(T.inDeSetKort, {
        prijs: geld(Math.round((geur.prijs * (100 - procent)) / 100)),
      });
      lijf.appendChild(prijs);

      kaart.appendChild(lijf);
      el.prevKaarten.appendChild(kaart);
    });

    el.prev.hidden = false;
  }

  /* --------------------------------------------------------------- bediening */

  /*
   * Eén knop voor beide toestanden van het setblok -- ingeklapt en uitgeklapt
   * is hetzelfde element -- dus één luisteraar volstaat. Hij loopt via alleZes,
   * net als de oude setknop: dezelfde meting, hetzelfde mandje.
   */
  if (el.setblokKnop) {
    el.setblokKnop.addEventListener('click', function () {
      alleZes(el.setblokKnop);
    });
  }

  if (el.setKnop) {
    el.setKnop.addEventListener('click', function () {
      alleZes(el.setKnop);
    });
  }

  if (el.stickyKnop) {
    el.stickyKnop.addEventListener('click', function () {
      alleZes(el.stickyKnop);
    });
  }


  el.start.addEventListener('click', function () {
    stap = 0;
    meetEens(NAMEN.gestart);
    if (el.terugval) el.terugval.hidden = true;
    toonUitslag(false);
    toon('vraag');
    tekenVraag();
  });

  /*
   * Aanmelden via het ingebedde Klaviyo-formulier onder de uitslag. Klaviyo
   * meldt zelf aan op de lijst van dat formulier; wij zetten daarna de uitslag
   * op het profiel (topmatch, de zes geuren, Quiz_code voor de link terug).
   * Bij een anonieme bezoeker kwam de identify van de uitslag nergens aan;
   * pas nu is bekend wie het is.
   */
  window.addEventListener('klaviyoForms', function (gebeurtenis) {
    var d = (gebeurtenis && gebeurtenis.detail) || {};
    if (d.type !== 'submit' || !T.klaviyoFormulier || d.formId !== T.klaviyoFormulier) return;
    if (!laatsteUitslag) return;
    var lading = Object.assign({}, laatsteUitslag);
    var adres = d.metaData && (d.metaData.$email || d.metaData.email);
    if (adres) lading.$email = adres;
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify(lading);
      else if (window._learnq) window._learnq.push(['identify', lading]);
    } catch (fout) {
      /* niets: de aanmelding zelf is via Klaviyo al gelukt */
    }
  });

  [el.bewaren].forEach(function (formulier) {
    if (!formulier) return;
    formulier.addEventListener('submit', function (gebeurtenis) {
      gebeurtenis.preventDefault();
      var veld = formulier.querySelector('input');
      if (!veld || !veld.value.trim()) return;

      var adres = veld.value.trim();
      var knop = formulier.querySelector('button');

      var api = window.klaviyo || window._learnq;
      if (api) {
        var lading = {};
        if (veld.type === 'email') lading.$email = adres;
        /*
         * De referentie blijft intern: alleen naar het profiel, nooit terug het
         * scherm op en nooit als vergelijking in copy.
         */
        else lading.Geurquiz_referentie = adres;
        lading.Quiz_code = naarCode(antwoorden);

        try {
          if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify(lading);
          else window._learnq.push(['identify', lading]);
        } catch (fout) {
          /* niets */
        }
      }

      veld.disabled = true;
      if (knop) knop.disabled = true;

      function gelukt() {
        formulier.classList.add('is-verstuurd');
        var melding = formulier.parentNode.querySelector('.gq-bewaard');
        if (!melding) {
          melding = elementje('p', 'gq-bewaard', '');
          melding.setAttribute('role', 'status');
          formulier.parentNode.appendChild(melding);
        }
        melding.textContent = T.uitslag.bewaardOk;
      }

      function mislukt() {
        veld.disabled = false;
        if (knop) knop.disabled = false;
        var melding = formulier.parentNode.querySelector('.gq-bewaard');
        if (!melding) {
          melding = elementje('p', 'gq-bewaard', '');
          melding.setAttribute('role', 'status');
          formulier.parentNode.appendChild(melding);
        }
        melding.textContent = T.uitslag.mislukt;
      }

      /*
       * Echt inschrijven op de lijst, niet alleen het profiel bijwerken.
       * identify() maakt wel een profiel maar zet niemand op een lijst en legt
       * geen toestemming vast -- dan kun je die mensen dus niet mailen.
       *
       * Dit loopt via ons eigen doorgeefluikje en niet rechtstreeks naar
       * Klaviyo. Reden: Klaviyo's client-eindpunt antwoordt op een
       * CORS-preflight met `access-control-allow-methods: OPTIONS` -- POST staat
       * daar niet bij, dus een browser blokkeert de aanroep. Gemeten, niet
       * aangenomen: hetzelfde verzoek vanaf een server geeft gewoon 202.
       *
       * Het doorgeefluikje gebruikt de PUBLIEKE sleutel en kent maar één lijst,
       * die in zijn eigen instellingen staat. Er valt dus niets anders mee te
       * doen dan wat een gewoon aanmeldformulier ook kan.
       */
      if (!T.aanmeldAdres || veld.type !== 'email' || !window.fetch) {
        gelukt();
        return;
      }

      window
        .fetch(T.aanmeldAdres, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: adres, bron: 'Geurquiz' }),
        })
        .then(function (res) {
          if (!res.ok) throw new Error('status ' + res.status);
          gelukt();
        })
        .catch(mislukt);
    });
  });

  /* ---------------------------------------------------------------- starten -- */

  function haalJson(url) {
    return window.fetch(url).then(function (res) {
      if (!res.ok) throw new Error(url + ': status ' + res.status);
      return res.json();
    });
  }

  /*
   * De keuring. Het bouwscript stopte met code 1 zodra een product een
   * verplicht veld miste -- dat was de poort die verhinderde dat er rommel in
   * de quiz kwam. Live bestaat die poort niet: een geur met een leeg metafield
   * rolt gewoon mee, kan nergens op scoren en zakt naar de bodem van élke
   * uitslag. Niemand die dat ziet, want een geur die nooit wint ziet er precies
   * uit als een geur die toevallig niet past.
   *
   * Daarom telt de quiz het zelf, bij elke weergave, en zegt het hardop.
   */
  function keuring(uit, rijen, verwacht) {
    var stuk = {};
    /* normaliseer() levert per ontbrekend veld een klacht; hier één regel per
     * geur, want een product mist er meestal meer tegelijk. */
    uit.klachten.forEach(function (k) {
      if (!stuk[k.handle]) stuk[k.handle] = { titel: k.titel, mist: [] };
      stuk[k.handle].mist.push(k.veld);
    });

    var kapot = Object.keys(stuk);

    return {
      geteld: rijen.length,
      verwacht: verwacht || 0,
      /* Meer producten in de collectie dan er gerenderd zijn: paginate heeft
       * afgekapt en de rest doet dus nergens meer aan mee. */
      afgekapt: verwacht > 0 && rijen.length < verwacht,
      bruikbaar: rijen.length - kapot.length,
      onbruikbaar: kapot.length,
      geuren: kapot.map(function (h) {
        return { handle: h, titel: stuk[h].titel, mist: stuk[h].mist };
      }),
      /* Een familielabel dat niet in quiz-config.json staat, maakt de geur
       * onbereikbaar voor vraag 2. Dit was in het bouwscript ook al fataal. */
      onbekendeFamilies: uit.onbekendeFamilies || [],
    };
  }

  /*
   * Mag deze live bron de quiz voeden? Eén product met een typefout is geen
   * reden om de hele collectie te laten vallen -- maar als de metafields
   * massaal leeg terugkomen, of paginate heeft afgekapt, dan is het gebouwde
   * bestand van gisteren aantoonbaar beter dan wat er nu op de pagina staat.
   */
  function bronDeugt(k, config) {
    if (!k.geteld) return false;
    if (k.afgekapt) return false;
    var eis = (config.bron && config.bron.minimum_bruikbaar) || 0.8;
    return k.bruikbaar / k.geteld >= eis;
  }

  /*
   * Hardop zeggen wat er mis is. Drie kanalen, want de winkelier zit niet in de
   * console te kijken:
   *
   * 1. console.warn -- altijd, ook voor wie er wél in kijkt.
   * 2. window.SentirGeurquizKeuring -- zodat een controlescript (of een collega
   *    met de devtools open) het rapport in één regel kan opvragen.
   * 3. Een balk bovenaan de quiz, maar UITSLUITEND in de theme editor of met
   *    ?geurquiz-keuring in de URL. Een klant hoort nooit te lezen dat er een
   *    metafield leeg is; de winkelier die de pagina in de editor opent wel, en
   *    dat is precies het moment waarop hij eraan kan doen.
   */
  function meldKeuring(k, deugt) {
    window.SentirGeurquizKeuring = k;

    var regels = [];
    if (k.afgekapt) {
      regels.push(
        'De collectie heeft ' + k.verwacht + ' producten maar er staan er ' + k.geteld +
          ' op de pagina. Boven de 250 kapt Liquid af.'
      );
    }
    if (k.onbekendeFamilies.length) {
      regels.push('Familielabels die niet in quiz-config.json staan: ' + k.onbekendeFamilies.join(', ') + '.');
    }
    k.geuren.forEach(function (g) {
      regels.push((g.titel || g.handle) + ' mist: ' + g.mist.join(', ') + '.');
    });

    if (!regels.length) return;

    /*
     * Of de terugval aansloeg is het belangrijkste wat de winkelier moet weten:
     * bij 'deugt' draait de quiz op wat hij net heeft aangepast, anders op het
     * gebouwde bestand en ziet hij zijn wijziging dus NIET terug.
     */
    var kopTekst = deugt
      ? k.onbruikbaar + ' van de ' + k.geteld + ' parfums kan de quiz niet volledig gebruiken. ' +
        'De rest werkt gewoon; deze geuren worden alleen zelden of nooit aangeraden.'
      : 'De live gegevens zijn afgekeurd. De quiz draait nu op assets/geurindex.json, ' +
        'dus wijzigingen in de admin zijn hier nog niet te zien.';

    console.warn('Geurquiz: ' + kopTekst + '\n' + regels.join('\n'));

    var mag = window.Shopify && window.Shopify.designMode;
    if (!mag && window.location.search.indexOf('geurquiz-keuring') === -1) return;

    var balk = document.createElement('div');
    balk.className = 'gq-keuring';
    balk.setAttribute('role', 'status');
    balk.style.cssText =
      'background:' + (deugt ? '#FDF3D8' : '#FBE3E0') + ';border:1px solid ' +
      (deugt ? '#C9A227' : '#C0392B') + ';color:' + (deugt ? '#5A4708' : '#7B241C') +
      ';padding:12px 16px;margin:0 0 16px;font:14px/1.5 system-ui,sans-serif;border-radius:8px';

    var kop = document.createElement('strong');
    kop.textContent = 'Alleen zichtbaar voor de winkelier: ' + kopTekst;
    balk.appendChild(kop);

    var lijst = document.createElement('ul');
    lijst.style.cssText = 'margin:8px 0 0;padding-left:20px';
    regels.forEach(function (r) {
      var li = document.createElement('li');
      li.textContent = r;
      lijst.appendChild(li);
    });
    balk.appendChild(lijst);

    wortel.insertBefore(balk, wortel.firstChild);
  }

  /*
   * De parfums komen bij voorkeur uit de pagina zelf: de sectie rendert ze
   * rechtstreeks uit de winkel, dus wat je in de admin verandert staat er bij
   * de eerstvolgende weergave in. Geen bestand om bij te werken.
   *
   * Lukt dat niet -- geen blok, kapotte JSON, een afgekapte collectie of massaal
   * lege metafields -- dan valt hij terug op assets/geurindex.json. Die staat er
   * nog en is hooguit een paar dagen oud. Een quiz die het even met oudere
   * gegevens doet is beter dan een quiz die niets of onzin toont.
   */
  function uitDePagina(config) {
    var blok = document.querySelector('[data-gq-bron]');
    if (!blok || !window.SentirGeurIndex) return null;
    try {
      var rijen = JSON.parse(blok.textContent);
      if (!rijen || !rijen.length) return null;

      var uit = window.SentirGeurIndex.normaliseer(rijen, config, {
        winkel: window.location.origin,
      });

      /*
       * De sectie zet erbij hoeveel producten de collectie telt, zodat we een
       * afgekapte paginate herkennen. Eerst keuren en melden, dan pas besluiten
       * -- viel de bron af, dan moet de winkelier juist wél horen waarom.
       */
      var verwacht = Number(blok.getAttribute('data-gq-bron-verwacht')) || 0;
      var k = keuring(uit, rijen, verwacht);
      var deugt = bronDeugt(k, config);
      meldKeuring(k, deugt);
      if (!deugt) return null;

      /*
       * Uitverkochte parfums doen niet mee. In het gebouwde bestand zat die
       * schifting al; hier moet hij zelf, want de bron levert alles.
       */
      var voorraad = {};
      rijen.forEach(function (r) { voorraad[r.handle] = r.voorraad !== false; });

      return {
        gemaakt: 'live',
        aantal: uit.aantal,
        notenNamen: uit.notenNamen,
        geuren: uit.geuren,
        klachten: uit.klachten,
        voorraad: voorraad,
      };
    } catch (fout) {
      /* Kapotte JSON in het blok mag de quiz niet meenemen in zijn val: het
       * gebouwde bestand staat er nog en doet het wel. */
      console.warn('Geurquiz: de live gegevens zijn niet te lezen, het gebouwde bestand wordt gebruikt.', fout);
      return null;
    }
  }

  haalJson(script.dataset.config)
    .then(function (conf) {
      config = conf;
      /* Het minimum bij de familievraag is een configknop, geen codewijziging. */
      if (config.vragen && config.vragen.min_families !== undefined) {
        VRAGEN[1].min = config.vragen.min_families;
      }
      if (config.vragen && config.vragen.max_noten) {
        VRAGEN[2].max = config.vragen.max_noten;
      }
      /* Ná het laden van de config, vóór de eerste uitslag: de proeven. */
      pasProevenToe();
      var live = uitDePagina(config);
      if (live) {
        index = live;
        return null;
      }
      return haalJson(script.dataset.index).then(function (bestand) {
        index = bestand;
        return null;
      });
    })
    .then(function () {

      tekenVoorproefje();

      var uitUrl = new URLSearchParams(window.location.search).get('r');
      var hervat = uitUrl ? uitCode(uitUrl) : haalOp();

      /*
       * Een gedeelde link opent meteen op de uitslag. Een halve sessie uit het
       * geheugen niet: die begint gewoon weer bij de vraag waar hij was.
       */
      if (hervat && hervat.v1 && hervat.v7) {
        antwoorden = hervat;
        afronden(false);
      } else if (hervat && hervat.v1) {
        antwoorden = hervat;
        stap = 0;
        /*
         * Wie halverwege terugkomt hoort ook als start te tellen, anders staat
         * er straks een voltooiing tegenover niets en lijkt de quiz beter te
         * scoren dan hij doet.
         */
        meetEens(NAMEN.gestart, { Hervat: true });
        toon('vraag');
        tekenVraag();
      }
    })
    .catch(function (fout) {
      console.warn('Geurquiz: de gegevens zijn niet geladen.', fout);
      if (el.start) el.start.disabled = true;
    });
})();
